<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-button
          @click="generateReportAll()"
          style="margin-bottom: 1rem; padding: 1rem; width: 100%"
          variant="primary"
        >
          Print Patient Report</b-button
        >
        <b-card no-body>
          <div class="timeline">
            <ul key="">
              <li
                v-for="(item, index) in itemsList"
                :key="index"
                @click="itemClicked(index)"
                :class="
                  itemClickedList.includes(index) ? 'clicked' : 'unclicked'
                "
              >
                <span>{{ item }}</span>
              </li>
            </ul>
          </div>
        </b-card>
      </b-col>
      <b-col md="9">
        <b-row>
          <b-col>
            <b-card>
              <template v-if="patientDataLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!patientDataLoading" class="pb-0">
                <div
                  class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
                >
                  <!-- Header: Left Content -->
                  <div>
                    <h2 class="mb-2">Patient Details:</h2>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">Patient Name:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          <span v-if="patientData.first_name">
                            {{ patientData.first_name + " " }}</span
                          >
                          <span v-if="patientData.second_name">
                            {{ patientData.second_name + " " }}</span
                          >
                          <span v-if="patientData.third_name">
                            {{ patientData.third_name + " " }}</span
                          >
                          <span v-if="patientData.forth_name">
                            {{ patientData.forth_name + " " }}</span
                          >
                          <span v-if="patientData.nickname">
                            {{ patientData.nickname }}</span
                          >
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">Patient Age:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          {{ patientData.age }}
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">Mother Name:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          <span v-if="patientData.first_mother_name">{{
                            patientData.first_mother_name + " "
                          }}</span>
                          <span v-if="patientData.second_mother_name">{{
                            patientData.second_mother_name + " "
                          }}</span>
                          <span v-if="patientData.third_mother_name">{{
                            patientData.third_mother_name + " "
                          }}</span>
                          <span v-if="patientData.forth_mother_name">{{
                            patientData.forth_mother_name
                          }}</span>
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">Main Phone Number:</h5>
                      </b-col>
                      <b-col class="mr-4" cols="auto">
                        <h5 class="font-weight-bold">
                          {{ patientData.phone }}
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">2nd Phone Number:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          {{ patientData.second_phone }}
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">Address:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          {{ cities[this.patientData.city_id - 1] }},
                          {{ patientData.adderss }}
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">National ID:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          {{ patientData.national_id }}
                          <span v-if="patientData.card_type"
                            >, (<span>{{ patientData.card_type }}</span
                            >)</span
                          >
                        </h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold"></h5>
                      </b-col>
                    </b-row>
                    <b-row class="mb-75">
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">Gender:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          {{ patientData.gender }}
                        </h5>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">Referral:</h5>
                      </b-col>
                      <b-col cols="auto">
                        <h5 class="font-weight-bold">
                          {{ patientData.patient_referred_from }}
                        </h5>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <br />
              </div>
            </b-card>
          </b-col>
        </b-row>
        <!-- First Visit -->
        <b-row v-if="itemClickedList.includes(0)">
          <b-col>
            <b-card>
              <template v-if="firstVisitLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!itemsField && !firstVisitLoading">
                <h3>This Patient has No First Visit Available</h3>
              </div>
              <div v-if="itemsField && !firstVisitLoading">
                <h2>First Visit :</h2>
                <div>
                  <b-row class="visit-row">
                    <b-col cols="6">
                      <div class="section-visit">
                        <h3>Presenting Symptom :</h3>
                        <ul>
                          <div v-if="itemsField.presenting_Symptom.default">
                            <li
                              v-for="item in itemsField.presenting_Symptom
                                .default"
                              v-bind:key="item"
                            >
                              {{ item }}
                            </li>
                            <li
                              v-if="itemsField.presenting_Symptom.default2"
                              v-for="item in itemsField.presenting_Symptom
                                .default2"
                              v-bind:key="item"
                            >
                              {{ item }}
                            </li>
                          </div>
                          <li v-if="itemsField.presenting_Symptom.bleeding">
                            bleeding
                            <ul
                              v-for="item in itemsField.presenting_Symptom
                                .bleeding"
                              v-bind:key="item"
                            >
                              <li>{{ item }}</li>
                            </ul>
                          </li>
                          <li v-if="itemsField.presenting_Symptom.infection">
                            infection :
                            {{ itemsField.presenting_Symptom.infection }}
                          </li>
                          <li v-if="itemsField.presenting_Symptom.others">
                            <span style="font-weight: 800">Others:</span>
                            {{ itemsField.presenting_Symptom.others }}
                          </li>
                        </ul>
                      </div>
                      <div class="section-visit">
                        <h3>Peformance State :</h3>
                        <!-- <ul v-for="item in itemsField.peformance_state" v-bind:key="item"> -->
                        <li v-if="itemsField.peformance_state">
                          <span class="mx-25 text-primary font-weight-bold">
                          </span
                          >{{ itemsField.peformance_state }}
                        </li>
                        <!-- </ul> -->
                      </div>
                      <div class="section-visit">
                        <h3>Initial Investigation Before Admission :</h3>
                        <ul>
                          <li
                            class="mb-2"
                            v-if="
                              itemsField.initial_investigation_before_admission
                                .cbc
                            "
                          >
                            <span class="font-weight-bold">CBC</span>
                            <span
                              style="float: right"
                              v-if="
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_cbcList
                              "
                              >Date:
                              {{
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_cbcList
                              }}</span
                            >
                            <table class="mt-75">
                              <tr>
                                <td>WBC</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .cbc.wbc
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .cbc.wbc
                                      : ""
                                  }}
                                </td>
                                <td>N%</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .cbc.n
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .cbc.n
                                      : ""
                                  }}
                                </td>
                                <td>L%</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .cbc.l
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .cbc.l
                                      : ""
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>Hb</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .cbc.hb
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .cbc.hb
                                      : ""
                                  }}
                                </td>
                                <td>Plt</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .cbc.plt
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .cbc.plt
                                      : ""
                                  }}
                                </td>
                                <td>Blast%</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .cbc.blast
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .cbc.blast
                                      : ""
                                  }}
                                </td>
                              </tr>
                            </table>
                          </li>
                          <li
                            class="mb-2"
                            v-if="
                              itemsField.initial_investigation_before_admission
                                .biochemistry
                            "
                          >
                            <span class="font-weight-bold">Biochemistry</span>
                            <span
                              style="float: right"
                              v-if="
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_admissionBiochemistryList
                              "
                              >Date:
                              {{
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_admissionBiochemistryList
                              }}</span
                            >
                            <table>
                              <tr>
                                <td>B urea</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.b_urea
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.b_urea
                                      : ""
                                  }}
                                </td>
                                <td>S crea</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.s_crea
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.s_crea
                                      : ""
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>S ca</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.s_ca
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.s_ca
                                      : ""
                                  }}
                                </td>
                                <td>Uric acid</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.uric_acid
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.uric_acid
                                      : ""
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>ALT</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.alt
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.alt
                                      : ""
                                  }}
                                </td>
                                <td>AST</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.ast
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.ast
                                      : ""
                                  }}
                                </td>
                              </tr>
                              <tr>
                                <td>ALP</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.alp
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.alp
                                      : ""
                                  }}
                                </td>
                                <td>TSB</td>
                                <td>
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .biochemistry.tsb
                                      ? itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.tsb
                                      : ""
                                  }}
                                </td>
                              </tr>
                            </table>
                          </li>
                          <div
                            v-if="
                              itemsField.initial_investigation_before_admission
                                .ultra_sound_rem
                            "
                          >
                            <li
                              class="my-3"
                              v-if="
                                itemsField
                                  .initial_investigation_before_admission
                                  .ultra_sound.Presence_of_Hepatomegaly ||
                                itemsField
                                  .initial_investigation_before_admission
                                  .ultra_sound.Presence_of_splenomegaly ||
                                itemsField
                                  .initial_investigation_before_admission
                                  .ultra_sound.Presence_of_LNpathy
                              "
                            >
                              <span class="font-weight-bold"
                                >Ultra Sound:
                                {{
                                  itemsField
                                    .initial_investigation_before_admission
                                    .ultra_sound_rem
                                }}</span
                              >
                              <span
                                style="float: right"
                                v-if="
                                  itemsField
                                    .initial_investigation_before_admission
                                    .dateValue_ultra_soundList
                                "
                                >Date:
                                {{
                                  itemsField
                                    .initial_investigation_before_admission
                                    .dateValue_ultra_soundList
                                }}</span
                              >
                              <ul
                                v-if="
                                  itemsField
                                    .initial_investigation_before_admission
                                    .ultra_sound_rem == 'remarkable'
                                "
                              >
                                <li
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .ultra_sound.Presence_of_Hepatomegaly
                                  "
                                >
                                  Presence of Hepatomegaly
                                </li>
                                <li
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .ultra_sound.Presence_of_splenomegaly
                                  "
                                >
                                  Presence of Splenomegaly
                                </li>
                                <li
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .ultra_sound.Presence_of_LNpathy
                                  "
                                >
                                  Presence of LNpathy :
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .ultra_sound.Presence_of_LNpathy
                                  }}
                                </li>
                              </ul>
                            </li>
                          </div>
                          <li
                            class="my-3"
                            v-if="
                              itemsField.initial_investigation_before_admission
                                .chest_x_ray
                            "
                          >
                            <span class="font-weight-bold"
                              >Chest X Ray :
                              {{
                                itemsField
                                  .initial_investigation_before_admission
                                  .chest_x_ray
                              }}</span
                            >
                            <span
                              style="float: right"
                              v-if="
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_chest_x_rayList
                              "
                              >Date:
                              {{
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_chest_x_rayList
                              }}</span
                            >
                          </li>
                          <li
                            class="my-1"
                            v-if="
                              itemsField.initial_investigation_before_admission
                                .blood_film
                            "
                          >
                            <span class="font-weight-bold">{{
                              itemsField.initial_investigation_before_admission
                                .blood_film
                            }}</span>
                            <span
                              style="float: right"
                              v-if="
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_blood_film_input
                              "
                              >Date:
                              {{
                                itemsField
                                  .initial_investigation_before_admission
                                  .dateValue_blood_film_input
                              }}</span
                            >
                          </li>
                          <li
                            class="mb-1"
                            v-if="
                              itemsField.initial_investigation_before_admission
                                .histopathological_report
                            "
                          >
                            Histopathological report :
                            {{
                              itemsField.initial_investigation_before_admission
                                .histopathological_report_value
                            }}
                          </li>
                          <li
                            class="mb-1"
                            v-if="
                              itemsField.initial_investigation_before_admission
                                .other_investigation
                            "
                          >
                            Other investigation :
                            {{
                              itemsField.initial_investigation_before_admission
                                .other_investigation_value
                            }}
                          </li>
                        </ul>
                      </div>
                      <div class="section-visit">
                        <h3>On Examination :</h3>
                        <ul>
                          <li
                            class="mb-1"
                            v-if="itemsField.on_examination.general_look"
                          >
                            General Look :
                            {{ itemsField.on_examination.general_look }}
                            <span
                              v-if="itemsField.on_examination.general_look"
                              style="color: blue"
                              >:
                              {{
                                itemsField.on_examination
                                  .general_look_remarkable
                              }}</span
                            >
                          </li>
                          <li
                            class="mb-1"
                            v-if="
                              itemsField.on_examination
                                .general_examination_check
                            "
                          >
                            General Examination

                            {{
                              itemsField.on_examination
                                .general_examination_check
                            }}

                            <ul
                              v-if="
                                itemsField.on_examination
                                  .general_examination_check
                              "
                            >
                              <li
                                v-for="(item, index) in itemsField
                                  .on_examination
                                  .general_examination_remarkable"
                                :key="index"
                              >
                                <span style="color: blue">{{ item }}</span>
                              </li>
                            </ul>
                          </li>
                          <li
                            class="mb-1"
                            v-if="itemsField.on_examination.chest_examination"
                          >
                            Chest Examination :
                            {{ itemsField.on_examination.chest_examination }}
                            <span
                              v-if="
                                itemsField.on_examination
                                  .chest_examination_remarkable
                              "
                              style="color: blue"
                              >:
                              {{
                                itemsField.on_examination
                                  .chest_examination_remarkable
                              }}</span
                            >
                          </li>
                          <li
                            class="mb-1"
                            v-if="
                              itemsField.on_examination.abdominal_examination
                            "
                          >
                            Abdominal Examination :
                            {{
                              itemsField.on_examination.abdominal_examination
                            }}
                            <span
                              v-if="
                                itemsField.on_examination
                                  .abdominal_examination_remarkable
                              "
                              style="color: blue"
                              >:
                              {{
                                itemsField.on_examination
                                  .abdominal_examination_remarkable
                              }}</span
                            >
                          </li>
                          <li
                            class="mb-1"
                            v-if="
                              itemsField.on_examination.neurological_examination
                            "
                          >
                            Neurological Examination :
                            {{
                              itemsField.on_examination.neurological_examination
                            }}
                            <span
                              v-if="
                                itemsField.on_examination
                                  .neurological_examination_remarkable
                              "
                              style="color: blue"
                              >:
                              {{
                                itemsField.on_examination
                                  .neurological_examination_remarkable
                              }}</span
                            >
                          </li>
                        </ul>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="section-visit">
                        <h3>Road Map :</h3>
                        <ul>
                          <li v-if="itemsField.road_map">
                            {{ itemsField.road_map }}
                          </li>
                        </ul>
                      </div>
                      <div class="section-visit">
                        <h3>Senior Impression :</h3>
                        <span
                          style="padding: 1rem"
                          v-if="itemsField.senior_impression"
                        >
                          <pre style="color: blue; padding: 1rem">{{
                            itemsField.senior_impression
                          }}</pre>
                        </span>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(1)">
          <b-col>
            <b-card>
              <template v-if="loadDiagnosis">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!Latestdiagnosis && !loadDiagnosis">
                <h3>This Patient has no Diagnosis Available</h3>
              </div>
              <div v-if="Latestdiagnosis && !loadDiagnosis">
                <h2>Latest Diagnosis :</h2>
                <br />
                <b-row>
                  <b-col>
                    <div>
                      <h3>- {{ Latestdiagnosis }}</h3>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(2)">
          <b-col>
            <b-card>
              <template v-if="loadPrognosis">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!Latestdiagnosis && !loadPrognosis">
                <h3>This Patient has no Risk Stratification Available</h3>
              </div>
              <div v-if="Latestdiagnosis && !loadPrognosis">
                <b-row>
                  <b-col cols="12">
                    <h2>
                      Risk Stratification for
                      <span style="color: blue">{{ Latestdiagnosis }}</span>
                    </h2>
                  </b-col>
                  <b-col cols="12"><br /><br /></b-col>
                  <b-col lg="12" xl="12">
                    <b-card
                      class="Risk_bg"
                      style="border-bottom: 3px solid rgb(25, 0, 255)"
                    >
                      <div v-for="(item, index) in patienPrognosisInfo">
                        <h4
                          v-if="
                            index != 'id' &&
                            index != 'created_at' &&
                            index != 'updated_at' &&
                            index != 'result' &&
                            index != 'patient_disease_id' &&
                            index != 'outCome' &&
                            index != 'score'
                          "
                          class="pb-75"
                        >
                          <b-row>
                            <b-col>
                              <span
                                v-if="
                                  prognosisTitle != 'ALL' ||
                                  index != 'cytogenetic'
                                "
                                >{{ index.replaceAll("_", " ") }}</span
                              >
                            </b-col>
                            <b-col class="border-left">
                              <span
                                v-if="
                                  prognosisTitle != 'ALL' ||
                                  index != 'cytogenetic'
                                "
                                >{{ item }}</span
                              >
                            </b-col>
                          </b-row>
                        </h4>
                        <!-- special output for ALL prognosis -->
                        <!-- TODO: Can be solve in less code if we did not get an object in the prognosis result -->
                        <div
                          v-if="
                            prognosisTitle == 'ALL' &&
                            (index == 'cytogenetic' || index == 'result')
                          "
                        >
                          <h4 class="pb-75">
                            <b-row
                              class="modify_result_display_div"
                              v-if="
                                prognosisTitle == 'ALL' && index == 'result'
                              "
                              style="
                                color: rgb(255, 255, 255);
                                margin-top: 1rem;
                              "
                            >
                              <b-col>
                                <span
                                  v-if="
                                    prognosisTitle != 'ALL' ||
                                    index != 'cytogenetic'
                                  "
                                  >{{ index.replaceAll("_", " ") }}</span
                                >
                              </b-col>
                              <b-col class="border-left">
                                <span
                                  v-if="
                                    prognosisTitle != 'ALL' ||
                                    index != 'cytogenetic'
                                  "
                                  >{{ item }}</span
                                >
                              </b-col>
                            </b-row>
                            <b-row
                              v-if="
                                prognosisTitle == 'ALL' &&
                                index == 'cytogenetic'
                              "
                              style="margin-top: 1rem"
                            >
                              <b-col
                                v-if="
                                  prognosisTitle == 'ALL' &&
                                  index == 'cytogenetic'
                                "
                              >
                                {{ Object.keys(item)[0].replaceAll("_", " ") }}
                              </b-col>
                              <b-col
                                v-if="
                                  prognosisTitle == 'ALL' &&
                                  index == 'cytogenetic'
                                "
                                class="border-left"
                              >
                                {{ item[Object.keys(item)[0]] }}
                              </b-col>
                            </b-row>
                            <b-row
                              v-if="
                                prognosisTitle == 'ALL' &&
                                index == 'cytogenetic'
                              "
                              style="margin-top: 2.5rem"
                            >
                              <b-col
                                style="margin: auto; display: block"
                                v-if="
                                  prognosisTitle == 'ALL' &&
                                  index == 'cytogenetic'
                                "
                              >
                                <span>{{
                                  Object.keys(item)[1].replaceAll("_", " ")
                                }}</span>
                              </b-col>
                              <b-col
                                v-if="
                                  prognosisTitle == 'ALL' &&
                                  index == 'cytogenetic'
                                "
                                class="border-left"
                              >
                                <span
                                  style="margin-top: 1.5rem; display: block"
                                  v-for="listItem in item[Object.keys(item)[1]]"
                                  >{{ listItem }}</span
                                >
                              </b-col>
                            </b-row>
                          </h4>
                        </div>
                        <div
                          :class="[
                            prognosisTitle == 'ALL' ? 'ALL-style' : '',
                            'modify_result_display_div',
                          ]"
                          v-if="
                            prognosisTitle != 'ALL' &&
                            (index == 'result' ||
                              index == 'outCome' ||
                              index == 'score')
                          "
                        >
                          <h4 class="modify_result_display">
                            <div>
                              <span class="pr-2" v-if="index == 'result'">
                                Result</span
                              >
                              <span class="pl-2" v-if="index == 'result'"
                                >: {{ item }}</span
                              >
                            </div>
                            <div>
                              <span class="pr-2" v-if="index == 'score'"
                                >Score</span
                              >
                              <span class="pl-2" v-if="index == 'score'"
                                >: {{ item }}</span
                              >
                            </div>
                            <div>
                              <span class="pr-2" v-if="index == 'outCome'">
                                OutCome
                              </span>
                              <span class="pl-2" v-if="index == 'outCome'"
                                >: [ PFS : {{ item.PFS }} -- OS :
                                {{ item.OS }} ]
                              </span>
                            </div>
                          </h4>
                        </div>
                      </div>
                    </b-card>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(3)">
          <b-col>
            <b-card>
              <template v-if="treatmentLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!treatmentForPatient && !treatmentLoading">
                <h3>This Patient has no Active Treatment Available</h3>
              </div>
              <div v-if="treatmentForPatient && !treatmentLoading">
                <b-card>
                  <div>
                    <h3>Chemotherapy Re-constitution Form</h3>
                  </div>
                  <b-row>
                    <b-col cols="12">
                      <div v-if="!treatmentLoading">
                        <div class="mt-2">
                          <table class="patient-table">
                            <tr>
                              <td>
                                Patient Name :
                                <span class="font-weight-bold">
                                  <span v-if="patientData.first_name">{{
                                    patientData.first_name + " "
                                  }}</span>
                                  <span v-if="patientData.second_name">{{
                                    patientData.second_name + " "
                                  }}</span>
                                  <span v-if="patientData.third_name">{{
                                    patientData.third_name + " "
                                  }}</span>
                                  <span v-if="patientData.forth_name">{{
                                    patientData.forth_name
                                  }}</span>
                                </span>
                              </td>
                              <td>
                                Age :
                                <span class="font-weight-bold">
                                  {{ patientData.age }}</span
                                >
                              </td>
                              <td>BSA :</td>
                            </tr>
                            <tr>
                              <td colspan="2">
                                Name of specialist :
                                <span class="font-weight-bold">
                                  {{
                                    treatmentForPatient.name_of_specialist
                                  }}</span
                                >
                              </td>
                              <td>
                                Date :
                                <span class="font-weight-bold">
                                  {{ treatmentForPatient.created_at }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Diagnosis :
                                <span class="font-weight-bold">
                                  {{ treatmentForPatient.daignosis }}</span
                                >
                              </td>
                              <!-- <td>Protocol name :
																<span class="font-weight-bold"> {{
																	treatmentForPatient.protocol.title
																}}</span>
															</td> -->
                              <td>
                                Number of dose :
                                <span class="font-weight-bold">
                                  {{ treatmentForPatient.number_of_dose }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>Case sheet number :</td>
                              <td>
                                Room number :
                                <span class="font-weight-bold">
                                  {{ treatmentForPatient.room_number }}</span
                                >
                              </td>
                              <td>
                                Gender :
                                <span class="font-weight-bold">
                                  {{ patientData.gender }}</span
                                >
                              </td>
                            </tr>
                          </table>
                          <br />
                          <table class="drugs-table">
                            <tr>
                              <td>No</td>
                              <td>Drug</td>
                              <td>Dose</td>
                              <td>Diluted in</td>
                              <td>Rout of administration</td>
                              <td>Time to start administration</td>
                              <td>Duration of administration</td>
                              <td>Note</td>
                            </tr>
                            <tr
                              v-for="i in treatmentForPatient.reconstitution_patient"
                            >
                              <td class="">
                                D
                                <span>{{ i.from_day }}</span>
                                <span v-if="i.to_day">/{{ i.to_day }}</span>
                              </td>
                              <td>{{ i.drug }}</td>
                              <td>{{ i.dose }}</td>
                              <td>{{ i.diluted_in }}</td>
                              <td>{{ i.route_of_administration }}</td>
                              <td v-if="i.time_to_start_administration">
                                {{ i.time_to_start_administration }}
                              </td>
                              <td v-if="!i.time_to_start_administration">-</td>
                              <td>{{ i.duration_of_administration }}</td>
                              <td v-if="i.notes">{{ i.notes }}</td>
                              <td v-if="!i.notes">-</td>
                            </tr>
                          </table>
                        </div>
                        <div class="mt-2">
                          <ul>
                            <li>
                              This should be signed first by the hematologist,
                              then the pharmacist, then the Re-constituter, and
                              finally by the nurse.
                            </li>
                            <li>
                              The nurse should compare this paper to what had
                              been written in the case sheet, which should be
                              100% compatible.
                            </li>
                            <li>
                              The premedication is not included, so the nurse
                              should check the case sheet.
                            </li>
                          </ul>
                        </div>
                        <div class="my-5 mx-2">
                          <table class="sign-table">
                            <tr>
                              <td>hematologist sign</td>
                              <td>Pharmacist sign</td>
                              <td>Re-constituter sign</td>
                              <td>Nurse</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(4)">
          <b-col>
            <b-card>
              <template v-if="latestTreatmentLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!latestTreatmentLoading && !latestTreatmentForPatient">
                <h3>This Patient has No Latest Treatment Available</h3>
              </div>
              <div v-if="!latestTreatmentLoading && latestTreatmentForPatient">
                <b-card>
                  <div v-if="!latestTreatmentLoading">
                    <h3>Chemotherapy Re-constitution Form</h3>
                  </div>
                  <b-row>
                    <b-col cols="12">
                      <div v-if="!latestTreatmentLoading">
                        <div class="mt-2">
                          <table class="patient-table">
                            <tr>
                              <td>
                                Patient Name :
                                <span class="font-weight-bold">
                                  <span v-if="patientData.first_name">{{
                                    patientData.first_name + " "
                                  }}</span>
                                  <span v-if="patientData.second_name">{{
                                    patientData.second_name + " "
                                  }}</span>
                                  <span v-if="patientData.third_name">{{
                                    patientData.third_name + " "
                                  }}</span>
                                  <span v-if="patientData.forth_name">{{
                                    patientData.forth_name
                                  }}</span>
                                </span>
                              </td>
                              <td>
                                Age :
                                <span class="font-weight-bold">
                                  {{ patientData.age }}</span
                                >
                              </td>
                              <td>BSA :</td>
                            </tr>
                            <tr>
                              <td colspan="2">
                                Name of specialist :
                                <span class="font-weight-bold">
                                  {{
                                    latestTreatmentForPatient.name_of_specialist
                                  }}</span
                                >
                              </td>
                              <td>
                                Date :
                                <span class="font-weight-bold">
                                  {{
                                    latestTreatmentForPatient.created_at
                                  }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Diagnosis :
                                <span class="font-weight-bold">
                                  {{
                                    latestTreatmentForPatient.daignosis
                                  }}</span
                                >
                              </td>
                              <td>
                                Protocol name :
                                <span class="font-weight-bold">
                                  {{
                                    latestTreatmentForPatient.protocol.title
                                  }}</span
                                >
                              </td>
                              <td>
                                Number of dose :
                                <span class="font-weight-bold">
                                  {{
                                    latestTreatmentForPatient.number_of_dose
                                  }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>Case sheet number :</td>
                              <td>
                                Room number :
                                <span class="font-weight-bold">
                                  {{
                                    latestTreatmentForPatient.room_number
                                  }}</span
                                >
                              </td>
                              <td>
                                Gender :
                                <span class="font-weight-bold">
                                  {{ patientData.gender }}</span
                                >
                              </td>
                            </tr>
                          </table>
                          <br />
                          <table class="drugs-table">
                            <tr>
                              <td>No</td>
                              <td>Drug</td>
                              <td>Dose</td>
                              <td>Diluted in</td>
                              <td>Rout of administration</td>
                              <td>Time to start administration</td>
                              <td>Duration of administration</td>
                              <td>Note</td>
                            </tr>
                            <tr
                              v-for="i in latestTreatmentForPatient.reconstitution_patient"
                            >
                              <td class="">
                                D
                                <span>{{ i.from_day }}</span>
                                <span v-if="i.to_day">/{{ i.to_day }}</span>
                              </td>
                              <td>{{ i.drug }}</td>
                              <td>{{ i.dose }}</td>
                              <td>{{ i.diluted_in }}</td>
                              <td>{{ i.route_of_administration }}</td>
                              <td v-if="i.time_to_start_administration">
                                {{ i.time_to_start_administration }}
                              </td>
                              <td v-if="!i.time_to_start_administration">-</td>
                              <td>{{ i.duration_of_administration }}</td>
                              <td v-if="i.notes">{{ i.notes }}</td>
                              <td v-if="!i.notes">-</td>
                            </tr>
                          </table>
                        </div>
                        <div class="mt-2">
                          <ul>
                            <li>
                              This should be signed first by the hematologist,
                              then the pharmacist, then the Re-constituter, and
                              finally by the nurse.
                            </li>
                            <li>
                              The nurse should compare this paper to what had
                              been written in the case sheet, which should be
                              100% compatible.
                            </li>
                            <li>
                              The premedication is not included, so the nurse
                              should check the case sheet.
                            </li>
                          </ul>
                        </div>
                        <div class="my-5 mx-2">
                          <table class="sign-table">
                            <tr>
                              <td>hematologist sign</td>
                              <td>Pharmacist sign</td>
                              <td>Re-constituter sign</td>
                              <td>Nurse</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(5)">
          <b-col>
            <b-card>
              <template v-if="relapseLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!relapseForPatient && !relapseLoading">
                <h3>This Patient has No Active Relapse Protocol Available</h3>
              </div>
              <div v-if="relapseForPatient && !relapseLoading">
                <b-card>
                  <div>
                    <h3>Chemotherapy Re-constitution Form</h3>
                  </div>
                  <b-row>
                    <b-col cols="12">
                      <div>
                        <div class="mt-2">
                          <table class="patient-table">
                            <tr>
                              <td>
                                Patient Name :
                                <span class="font-weight-bold">
                                  <span v-if="patientData.first_name">{{
                                    patientData.first_name + " "
                                  }}</span>
                                  <span v-if="patientData.second_name">{{
                                    patientData.second_name + " "
                                  }}</span>
                                  <span v-if="patientData.third_name">{{
                                    patientData.third_name + " "
                                  }}</span>
                                  <span v-if="patientData.forth_name">{{
                                    patientData.forth_name
                                  }}</span>
                                </span>
                              </td>
                              <td>
                                Age :
                                <span class="font-weight-bold">
                                  {{ patientData.age }}</span
                                >
                              </td>
                              <td>BSA :</td>
                            </tr>
                            <tr>
                              <td colspan="2">
                                Name of specialist :
                                <span class="font-weight-bold">
                                  {{
                                    relapseForPatient.name_of_specialist
                                  }}</span
                                >
                              </td>
                              <td>
                                Date :
                                <span class="font-weight-bold">
                                  {{ relapseForPatient.created_at }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Diagnosis :
                                <span class="font-weight-bold">
                                  {{ relapseForPatient.daignosis }}</span
                                >
                                <!--  DiseaseCategory[relapseForPatient.protocol.disease_category_id-1] -->
                              </td>
                              <!-- <td>Protocol name :
																<span class="font-weight-bold"> {{
																	relapseForPatient.protocol.title
																}}</span>
															</td> -->
                              <td>
                                Number of dose :
                                <span class="font-weight-bold">
                                  {{ relapseForPatient.number_of_dose }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>Case sheet number :</td>
                              <td>
                                Room number :
                                <span class="font-weight-bold">
                                  {{ relapseForPatient.room_number }}</span
                                >
                              </td>
                              <td>
                                Gender :
                                <span class="font-weight-bold">
                                  {{ patientData.gender }}</span
                                >
                              </td>
                            </tr>
                          </table>
                          <br />
                          <table class="drugs-table">
                            <tr>
                              <td>No</td>
                              <td>Drug</td>
                              <td>Dose</td>
                              <td>Diluted in</td>
                              <td>Rout of administration</td>
                              <td>Time to start administration</td>
                              <td>Duration of administration</td>
                              <td>Note</td>
                            </tr>
                            <tr
                              v-for="i in relapseForPatient.reconstitution_patient"
                            >
                              <td class="">
                                D
                                <span>{{ i.from_day }}</span>
                                <span v-if="i.to_day">/{{ i.to_day }}</span>
                              </td>
                              <td>{{ i.drug }}</td>
                              <td>{{ i.dose }}</td>
                              <td>{{ i.diluted_in }}</td>
                              <td>{{ i.route_of_administration }}</td>
                              <td v-if="i.time_to_start_administration">
                                {{ i.time_to_start_administration }}
                              </td>
                              <td v-if="!i.time_to_start_administration">-</td>
                              <td>{{ i.duration_of_administration }}</td>
                              <td v-if="i.notes">{{ i.notes }}</td>
                              <td v-if="!i.notes">-</td>
                            </tr>
                          </table>
                        </div>
                        <div class="mt-2">
                          <ul>
                            <li>
                              This should be signed first by the hematologist,
                              then the pharmacist, then the Re-constituter, and
                              finally by the nurse.
                            </li>
                            <li>
                              The nurse should compare this paper to what had
                              been written in the case sheet, which should be
                              100% compatible.
                            </li>
                            <li>
                              The premedication is not included, so the nurse
                              should check the case sheet.
                            </li>
                          </ul>
                        </div>
                        <div class="my-5 mx-2">
                          <table class="sign-table">
                            <tr>
                              <td>hematologist sign</td>
                              <td>Pharmacist sign</td>
                              <td>Re-constituter sign</td>
                              <td>Nurse</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(6)">
          <b-col>
            <b-card>
              <template v-if="latestRelapseLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!latestRelapseForPatient && !latestRelapseLoading">
                <h3>This Patient has No Latest Relapse Protocol Available</h3>
              </div>
              <div>
                <b-card v-if="latestRelapseForPatient && !latestRelapseLoading">
                  <div>
                    <h3>Chemotherapy Re-constitution Form</h3>
                  </div>
                  <b-row>
                    <b-col cols="12">
                      <div>
                        <div class="mt-2">
                          <table class="patient-table">
                            <tr>
                              <td>
                                Patient Name :
                                <span class="font-weight-bold">
                                  <span v-if="patientData.first_name">{{
                                    patientData.first_name + " "
                                  }}</span>
                                  <span v-if="patientData.second_name">{{
                                    patientData.second_name + " "
                                  }}</span>
                                  <span v-if="patientData.third_name">{{
                                    patientData.third_name + " "
                                  }}</span>
                                  <span v-if="patientData.forth_name">{{
                                    patientData.forth_name
                                  }}</span>
                                </span>
                              </td>
                              <td>
                                Age :
                                <span class="font-weight-bold">
                                  {{ patientData.age }}</span
                                >
                              </td>
                              <td>BSA :</td>
                            </tr>
                            <tr>
                              <td colspan="2">
                                Name of specialist :
                                <span class="font-weight-bold">
                                  {{
                                    latestRelapseForPatient.name_of_specialist
                                  }}</span
                                >
                              </td>
                              <td>
                                Date :
                                <span class="font-weight-bold">
                                  {{ latestRelapseForPatient.created_at }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>
                                Diagnosis :
                                <span class="font-weight-bold">
                                  {{ latestRelapseForPatient.daignosis }}</span
                                >
                              </td>
                              <td>
                                Protocol name :
                                <!-- <span class="font-weight-bold"> {{
																	latestRelapseForPatient.protocol.title
																}}</span> -->
                              </td>
                              <td>
                                Number of dose :
                                <span class="font-weight-bold">
                                  {{
                                    latestRelapseForPatient.number_of_dose
                                  }}</span
                                >
                              </td>
                            </tr>
                            <tr>
                              <td>Case sheet number :</td>
                              <td>
                                Room number :
                                <span class="font-weight-bold">
                                  {{
                                    latestRelapseForPatient.room_number
                                  }}</span
                                >
                              </td>
                              <td>
                                Gender :
                                <span class="font-weight-bold">
                                  {{ patientData.gender }}</span
                                >
                              </td>
                            </tr>
                          </table>
                          <br />
                          <table class="drugs-table">
                            <tr>
                              <td>No</td>
                              <td>Drug</td>
                              <td>Dose</td>
                              <td>Diluted in</td>
                              <td>Rout of administration</td>
                              <td>Time to start administration</td>
                              <td>Duration of administration</td>
                              <td>Note</td>
                            </tr>
                            <tr
                              v-for="i in latestRelapseForPatient.reconstitution_patient"
                            >
                              <td class="">
                                D
                                <span>{{ i.from_day }}</span>
                                <span v-if="i.to_day">/{{ i.to_day }}</span>
                              </td>
                              <td>{{ i.drug }}</td>
                              <td>{{ i.dose }}</td>
                              <td>{{ i.diluted_in }}</td>
                              <td>{{ i.route_of_administration }}</td>
                              <td v-if="i.time_to_start_administration">
                                {{ i.time_to_start_administration }}
                              </td>
                              <td v-if="!i.time_to_start_administration">-</td>
                              <td>{{ i.duration_of_administration }}</td>
                              <td v-if="i.notes">{{ i.notes }}</td>
                              <td v-if="!i.notes">-</td>
                            </tr>
                          </table>
                        </div>
                        <div class="mt-2">
                          <ul>
                            <li>
                              This should be signed first by the hematologist,
                              then the pharmacist, then the Re-constituter, and
                              finally by the nurse.
                            </li>
                            <li>
                              The nurse should compare this paper to what had
                              been written in the case sheet, which should be
                              100% compatible.
                            </li>
                            <li>
                              The premedication is not included, so the nurse
                              should check the case sheet.
                            </li>
                          </ul>
                        </div>
                        <div class="my-5 mx-2">
                          <table class="sign-table">
                            <tr>
                              <td>hematologist sign</td>
                              <td>Pharmacist sign</td>
                              <td>Re-constituter sign</td>
                              <td>Nurse</td>
                            </tr>
                          </table>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(7)">
          <!-- Patient Consultation -->
          <b-col>
            <b-card>
              <template v-if="latestConsultationLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!latestConsultation && !latestConsultationLoading">
                <h3>This Patient has No Latest Consultation Available</h3>
              </div>
              <b-card-body
                v-if="latestConsultation && !latestConsultationLoading"
              >
                <b-row>
                  <div>
                    <h2>Consultation</h2>
                    <br />
                    <b-row>
                      <b-col cols="6">
                        <div class="section-consultant">
                          <div>
                            <span class="h5">Date of Consultation : </span
                            ><span class="h5 text-muted">{{
                              latestConsultation.date_of_consultation
                            }}</span>
                          </div>
                        </div>
                        <div class="section-consultant">
                          <div>
                            <span class="h5">Consulting Site : </span
                            ><span class="h5 text-primary">{{
                              latestConsultation.consulting_site
                            }}</span>
                          </div>
                        </div>
                      </b-col>
                      <b-col cols="6">
                        <div class="section-consultant">
                          <div>
                            <span class="h5">Cause of Consultation : </span
                            ><span class="h5 text-primary">{{
                              latestConsultation.cause_of_consultation
                            }}</span>
                          </div>
                        </div>
                        <div class="section-consultant">
                          <div>
                            <span class="h5">Management : </span
                            ><span class="h5 text-primary">{{
                              latestConsultation.management
                            }}</span>
                          </div>
                        </div>
                      </b-col>

                      <b-col cols="12">
                        <div class="section-consultant">
                          <h3 class="pb-1">Consulting Paper File :</h3>
                          <img
                            class="modify-consulting-paper"
                            :src="latestConsultation.consulting_paper_file"
                            alt=""
                          />
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </b-row>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(8)">
          <!-- Patient Emergency -->
          <b-col>
            <b-card>
              <template v-if="latestEmergencyLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!latestEmergency && !latestEmergencyLoading">
                <h3>This Patient has No Latest Emergency Available</h3>
              </div>
              <b-card-body v-if="latestEmergency && !latestEmergencyLoading">
                <div>
                  <h2>Emergency</h2>
                  <b-row class="visit-row">
                    <b-col md="6">
                      <div class="section-consultant">
                        <div>
                          <span class="h5">Time of Admission : </span
                          ><span class="h5 text-muted">{{
                            latestEmergency.date_admission
                          }}</span>
                        </div>
                      </div>
                      <div class="section-consultant">
                        <h5>Vital Sign on Admission:</h5>
                        <h5
                          class="pt-2"
                          v-if="latestEmergency.glasgow_coma_scale_total_score"
                        >
                          <span class="pr-1 total_score text-primary"
                            >Total score :
                            {{ latestEmergency.glasgow_coma_scale_total_score }}
                          </span>
                          <span
                            class="ml-1 total_score text-success"
                            v-if="
                              latestEmergency.glasgow_coma_scale_total_score ==
                              15
                            "
                          >
                            Best Score
                          </span>
                          <span
                            class="ml-1 total_score text-warning"
                            v-if="
                              latestEmergency.glasgow_coma_scale_total_score <=
                                8 &&
                              latestEmergency.glasgow_coma_scale_total_score > 3
                            "
                          >
                            Comatosed
                          </span>
                          <span
                            class="ml-1 total_score text-danger"
                            v-if="
                              latestEmergency.glasgow_coma_scale_total_score ==
                              3
                            "
                          >
                            Unresponsive
                          </span>
                        </h5>
                      </div>
                      <div
                        v-if="latestEmergency.vital_sign_on_admission"
                        class="section-consultant"
                      >
                        <div
                          class="mt-75"
                          v-if="
                            latestEmergency.vital_sign_on_admission
                              .blood_pressure
                          "
                        >
                          <span class="h5">Blood Pressure : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.vital_sign_on_admission
                              .blood_pressure
                          }}</span>
                        </div>
                        <div
                          class="mt-75"
                          v-if="
                            latestEmergency.vital_sign_on_admission.pulse_rate
                          "
                        >
                          <span class="h5">Pulse Rate : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.vital_sign_on_admission.pulse_rate
                          }}</span>
                        </div>
                        <div
                          class="mt-75"
                          v-if="
                            latestEmergency.vital_sign_on_admission
                              .oxygen_saturation
                          "
                        >
                          <span class="h5">Oxygen Saturation : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.vital_sign_on_admission
                              .oxygen_saturation
                          }}</span>
                        </div>
                        <div
                          class="my-75"
                          v-if="
                            latestEmergency.vital_sign_on_admission
                              .respiratory_rate
                          "
                        >
                          <span class="h5">Respiratory Rate : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.vital_sign_on_admission
                              .respiratory_rate
                          }}</span>
                        </div>
                      </div>
                    </b-col>
                    <b-col cols="6">
                      <div class="section-visit-sec">
                        <div>
                          <span class="h5">Admitted By : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.admitted_by
                          }}</span>
                        </div>
                      </div>
                      <div class="section-visit-sec">
                        <div>
                          <span class="h5">Cause of Admission : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.cause_of_admission
                          }}</span>
                        </div>
                      </div>
                      <div class="section-visit-sec">
                        <div>
                          <span class="h5">Treatment Received : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.treatment_received
                          }}</span>
                        </div>
                      </div>
                      <div class="section-visit-sec">
                        <div>
                          <span class="h5">State on Discharge : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.state_on_discharge
                          }}</span>
                        </div>
                      </div>
                      <div class="section-visit-sec">
                        <div>
                          <span class="h5">Referred To : </span
                          ><span class="h5 text-primary">{{
                            latestEmergency.referred_to
                          }}</span>
                        </div>
                      </div>
                    </b-col>
                    <b-col md="12">
                      <div
                        v-if="latestEmergency.summery_of_the_patient_condition"
                        class="section-visit-summery"
                      >
                        <h5
                          v-if="
                            latestEmergency.summery_of_the_patient_condition
                          "
                        >
                          Summery of The Patient Condition :
                        </h5>
                        <div class="summery">
                          {{ latestEmergency.summery_of_the_patient_condition }}
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(9)">
          <b-col>
            <b-card>
              <template v-if="latestSubsequentLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!subsequentVisitData && !latestSubsequentLoading">
                <h3>This Patient has No Latest Subsequent Visit Available</h3>
              </div>
              <div
                v-for="item in subsequentVisitData"
                v-if="subsequentVisitData && !latestSubsequentLoading"
              >
                <br />
                <h2>
                  Subsequent Visit at
                  {{
                    item.created_at.slice(0, 10) +
                    " " +
                    item.created_at.slice(11, 19)
                  }}
                </h2>
                <br />
                <br />
                <b-row>
                  <b-col md="6">
                    <div class="section-visit">
                      <h4>I. Department :</h4>
                      {{ item.departments }}
                    </div>
                    <div v-if="item.emergency.key" class="section-visit">
                      <h4>II. Has an Emergent presentation :</h4>
                      <span>{{ item.emergency.key }}</span>
                      <span v-if="item.emergency.value"
                        >- {{ item.emergency.value }}</span
                      >
                    </div>
                    <div
                      class="section-visit"
                      v-if="
                        item.emergency.key == 'Yes' && item.emergency_action
                      "
                    >
                      <h4>III. Emergency action :</h4>
                      <span>{{ item.emergency_action }}</span>
                    </div>
                    <div
                      v-if="item.supportive_treatment.Antibiotic.length"
                      class="section-visit"
                    >
                      <h4>VI. Antibiotic used :</h4>
                      <ul v-for="item in item.supportive_treatment.Antibiotic">
                        <li>{{ item }}</li>
                      </ul>
                    </div>
                    <div
                      v-if="item.supportive_treatment.Antifungal.length"
                      class="section-visit"
                    >
                      <h4>VII. Antifungal used :</h4>
                      <ul v-for="item in item.supportive_treatment.Antifungal">
                        <li>{{ item }}</li>
                      </ul>
                    </div>
                    <div
                      v-if="item.supportive_treatment.key"
                      class="section-visit"
                    >
                      <h4>VIII. Supportive treatment :</h4>
                      <ul>
                        <li>{{ item.supportive_treatment.key }}</li>
                      </ul>
                    </div>

                    <div v-if="item.outcome.key" class="section-visit">
                      <h4>IX. Outcome / action plan :</h4>
                      <span>{{ item.outcome.key }} </span>
                    </div>
                    <div
                      v-if="item.outcome.death.key.length"
                      class="section-visit"
                    >
                      <h4>X. Death :</h4>
                      <span>
                        <ul v-for="item in item.outcome.death.key">
                          <li v-if="item == 'Cause Of Death'">
                            {{ item }}
                            <span v-if="item.outcome.death.CauseOfDeath.key">
                              :
                              {{ item.outcome.death.CauseOfDeath.key }}
                              <span
                                v-if="item.outcome.death.CauseOfDeath.value"
                              >
                              </span>
                            </span>
                          </li>
                          <li v-if="item == 'State Of Disease At Death'">
                            {{ item }}
                            <span
                              v-if="item.outcome.death.StateOfDiseaseAtDeath"
                              >:
                              {{
                                item.outcome.death.StateOfDiseaseAtDeath
                              }}</span
                            >
                          </li>
                        </ul>
                      </span>
                    </div>
                    <div
                      v-if="item.supportive_treatment.next_appointment"
                      class="section-visit"
                    >
                      <h4>XI. Next appointment :</h4>
                      <span>{{
                        item.supportive_treatment.next_appointment.slice(0, 10)
                      }}</span>
                    </div>
                    <div class="section-visit">
                      <h4>XII. Senior impression :</h4>
                      <span>- {{ item.senior_impression }}</span>
                    </div>
                  </b-col>
                  <b-col md="6">
                    <div v-if="item.causes.list.length" class="section-visit">
                      <h4>III. Cause(s) :</h4>
                      <ul v-for="itemList in item.causes.list">
                        <li v-if="itemList == 'Chemotherapy date'">
                          {{ itemList }}
                        </li>
                        <li v-if="itemList == 'Date of assessment'">
                          {{ itemList }}
                        </li>
                        <li v-if="itemList == 'Follow up date'">
                          {{ itemList }}
                          <ul v-for="secItem in item.causes.followUpDate.key">
                            <li v-if="secItem == 'Duration of follow up'">
                              {{ secItem }} :
                              <span>{{
                                item.causes.followUpDate.durationOfFollowUp
                              }}</span>
                            </li>
                            <li v-if="secItem == 'Any significant symptoms'">
                              {{ secItem }} :
                              <span>{{
                                item.causes.followUpDate.anySignificantSymptoms
                              }}</span>
                            </li>
                            <li v-if="secItem == 'The last assessment'">
                              {{ secItem }} :
                              <span>{{
                                item.causes.followUpDate.theLastAssessment
                              }}</span>
                            </li>
                          </ul>
                        </li>
                        <li v-if="itemList == 'Break Through event'">
                          {{ itemList }}

                          <ul
                            v-if="item.causes.breakThrough.length"
                            v-for="item in item.causes.breakThrough"
                          >
                            <li v-if="item == 'Fever'">
                              {{ item }}
                              <ul>
                                <li v-if="item.causes.fever.duration">
                                  Duration:
                                  {{ item.causes.fever.duration }} days
                                </li>
                                <li
                                  v-if="
                                    item.causes.fever.prophylacticUseOf.length
                                  "
                                >
                                  Was on prophylactic use of:
                                  <ul
                                    v-for="secItem in item.causes.fever
                                      .prophylacticUseOf"
                                  >
                                    <li>{{ secItem }}</li>
                                  </ul>
                                </li>
                                <li
                                  v-if="item.causes.fever.focusOfInfection.key"
                                >
                                  {{ item.causes.fever.focusOfInfection.key }}
                                  <span
                                    v-if="
                                      item.causes.fever.focusOfInfection.value
                                    "
                                  >
                                    -
                                    {{
                                      item.causes.fever.focusOfInfection.value
                                    }}
                                  </span>
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'Lymphadenopathy'">
                              {{ item }}
                              <ul
                                v-for="secItem in item.causes.Lymphadenopathy
                                  .key"
                              >
                                <li v-if="secItem == 'Site'">
                                  {{ secItem }} :
                                  <ul
                                    v-for="thirdItem in item.causes
                                      .Lymphadenopathy.site"
                                  >
                                    <li>{{ thirdItem }}</li>
                                  </ul>
                                </li>
                                <li v-if="secItem == 'Size'">
                                  {{ secItem }} :
                                  <span>{{
                                    item.causes.Lymphadenopathy.size
                                  }}</span>
                                </li>
                              </ul>
                            </li>
                            <li
                              v-if="
                                item ==
                                'Evaluation of abnormal peripheral blood'
                              "
                            >
                              {{ item }}
                              <ul
                                v-for="secItem in item.causes
                                  .EvaluationOfAbnormalPeripheralBlood.key"
                              >
                                <li v-if="secItem == 'Leukocytosis'">
                                  {{ secItem }}
                                  <ul
                                    v-for="thirdItem in item.causes
                                      .EvaluationOfAbnormalPeripheralBlood
                                      .Leukocytosis"
                                  >
                                    <li>{{ thirdItem }}</li>
                                  </ul>
                                </li>
                                <li v-if="secItem == 'Abnormal cell'">
                                  {{ secItem }}
                                  <ul
                                    v-for="thirdItem in item.causes
                                      .EvaluationOfAbnormalPeripheralBlood
                                      .AbnormalCell"
                                  >
                                    <li>{{ thirdItem }}</li>
                                  </ul>
                                </li>
                                <li v-if="secItem == 'Abnormal RBC morphology'">
                                  {{ secItem }}
                                  <ul
                                    v-for="thirdItem in item.causes
                                      .EvaluationOfAbnormalPeripheralBlood
                                      .AbnormalRBCMorphology"
                                  >
                                    <li>{{ thirdItem }}</li>
                                  </ul>
                                </li>
                                <li v-else>
                                  {{ secItem }}
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'Bleeding'">
                              {{ item }}
                              <ul v-for="secItem in item.causes.Bleeding.key">
                                <li v-if="secItem == 'Site'">
                                  {{ secItem }} :
                                  <span v-if="item.causes.Bleeding.Site">{{
                                    item.causes.Bleeding.Site
                                  }}</span>
                                </li>
                                <li v-if="secItem == 'Duration'">
                                  {{ secItem }} :
                                  <span v-if="item.causes.Bleeding.Duration"
                                    >{{
                                      item.causes.Bleeding.Duration
                                    }}
                                    days</span
                                  >
                                </li>
                                <li v-if="secItem == 'Severity'">
                                  {{ secItem }} :
                                  <span v-if="item.causes.Bleeding.Severity">{{
                                    item.causes.Bleeding.Severity
                                  }}</span>
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'Mass evaluation'">
                              {{ item }}
                              <ul
                                v-for="secItem in item.causes.massEvaluation
                                  .key"
                              >
                                <li v-if="secItem == 'Site'">
                                  {{ secItem }} :
                                  <ul
                                    v-for="thirdItem in item.causes
                                      .massEvaluation.site"
                                  >
                                    <li>{{ thirdItem }}</li>
                                  </ul>
                                </li>
                                <li v-if="secItem == 'Size'">
                                  {{ secItem }} :
                                  <span v-if="item.causes.massEvaluation.size"
                                    >{{
                                      item.causes.massEvaluation.size
                                    }}
                                    cm</span
                                  >
                                </li>
                                <li v-if="secItem == 'Descriptions'">
                                  {{ secItem }} :
                                  <span
                                    v-if="
                                      item.causes.massEvaluation.descriptions
                                    "
                                    >{{
                                      item.causes.massEvaluation.descriptions
                                    }}</span
                                  >
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'Skin rash'">
                              {{ item }}
                              <ul v-for="secItem in item.causes.skinRash.key">
                                <li v-if="secItem == 'Site'">
                                  {{ secItem }} :
                                  <span v-if="item.causes.skinRash.Site">{{
                                    item.causes.skinRash.Site
                                  }}</span>
                                </li>
                                <li
                                  v-if="
                                    secItem == 'Percentage Of Skin Involvement'
                                  "
                                >
                                  {{ secItem }} :
                                  <span
                                    v-if="
                                      item.causes.skinRash
                                        .percentageOfSkinInvolvement
                                    "
                                    >{{
                                      item.causes.skinRash
                                        .percentageOfSkinInvolvement
                                    }}
                                    %</span
                                  >
                                </li>
                                <li v-if="secItem == 'Descriptions Of Rash'">
                                  {{ secItem }} :
                                  <ul
                                    v-for="thirdItem in item.causes.skinRash
                                      .descriptionOfRash"
                                  >
                                    <li>{{ thirdItem }}</li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                            <li
                              v-if="item == 'Evaluation of abnormal blood test'"
                            >
                              {{ item }}
                              <ul
                                v-for="secItem in item.causes
                                  .EvaluationOfAbnormalBloodTest.key"
                              >
                                <li>
                                  {{ secItem }}
                                  <span
                                    v-if="
                                      item.causes.EvaluationOfAbnormalBloodTest
                                        .value
                                    "
                                  >
                                    -
                                    {{
                                      item.causes.EvaluationOfAbnormalBloodTest
                                        .value
                                    }}</span
                                  >
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'Locomotor presentation'">
                              {{ item }}
                              <ul
                                v-for="secItem in item.causes
                                  .LocomotorPresentation.key"
                              >
                                <li>
                                  {{ secItem }}
                                  <span
                                    v-if="
                                      item.causes.LocomotorPresentation.value
                                    "
                                  >
                                    -
                                    {{
                                      item.causes.LocomotorPresentation.value
                                    }}</span
                                  >
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'Thrombosis'">
                              {{ item }}
                              <ul v-for="secItem in item.causes.Thrombosis.key">
                                <li v-if="secItem == 'Site'">
                                  {{ secItem }} :
                                  <ul
                                    v-for="thirdItem in item.causes.Thrombosis
                                      .site"
                                  >
                                    <li>{{ thirdItem }}</li>
                                  </ul>
                                </li>
                                <li
                                  v-if="secItem == 'Single site vs Multiple?'"
                                >
                                  {{ secItem }} :
                                  <span>{{
                                    item.causes.Thrombosis.SingleVMultiple
                                  }}</span>
                                </li>
                                <li
                                  v-if="secItem == 'First attack vs Recurrent?'"
                                >
                                  {{ secItem }} :
                                  <span>{{
                                    item.causes.Thrombosis.FirstVRecurrent
                                  }}</span>
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'Neurological presentation'">
                              {{ item }}
                              <ul
                                v-for="secItem in item.causes
                                  .NeurologicalPresentation.key"
                              >
                                <li>
                                  {{ secItem }}
                                  <span
                                    v-if="
                                      item.causes.NeurologicalPresentation.value
                                    "
                                  >
                                    -
                                    {{
                                      item.causes.NeurologicalPresentation.value
                                    }}</span
                                  >
                                </li>
                              </ul>
                            </li>
                            <li v-if="item == 'GIT presentation'">
                              {{ item }}
                              <ul
                                v-for="secItem in item.causes.GITPresentation
                                  .key"
                              >
                                <li>
                                  {{ secItem }}
                                  <span
                                    v-if="
                                      item.causes.GITPresentation.key ==
                                      'Loss of weight'
                                    "
                                  >
                                    :
                                    {{
                                      item.causes.GITPresentation.LossOfWeight
                                    }}
                                    %
                                  </span>
                                  <span
                                    v-if="
                                      item.causes.GITPresentation.key == 'value'
                                    "
                                  >
                                    :
                                    {{
                                      item.causes.GITPresentation.value
                                    }}</span
                                  >
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(10)">
          <b-col>
            <b-card>
              <template v-if="latestSupportiveLoading">
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
              <div v-if="!latestSupportiveInfo && !latestSupportiveLoading">
                <h3>This Patient has No Latest Supportive Visit Available</h3>
              </div>
              <div v-if="latestSupportiveInfo && !latestSupportiveLoading">
                <h2 class="mb-2">Supportive</h2>
                <br /><br />
                <div>
                  <h4 style="display: inline" class="ml-1">
                    Blood group &RH :
                    <span class="ml-1 text-primary">{{
                      latestSupportiveInfo.blood_group_rh
                    }}</span>
                  </h4>
                  <br /><br /><br />
                  <div>
                    <h4 class="ml-1 mb-1">
                      Is the patient need irradiated blood component?
                      <span class="ml-1 text-primary">{{
                        latestSupportiveInfo.is_need_irradiated_blood.key
                      }}</span>
                    </h4>
                    <h5
                      class="ml-1 mb-1 text-primary"
                      v-if="
                        latestSupportiveInfo.is_need_irradiated_blood.key ==
                        'Yes'
                      "
                    >
                      - Because he/she known case of :
                      <span class="ml-1 text-primary">
                        {{
                          latestSupportiveInfo.is_need_irradiated_blood.value
                        }}
                      </span>
                    </h5>
                  </div>
                  <br /><br />
                  <div>
                    <h4 class="ml-1 mb-1">
                      has allergy from blood component previously?
                      <span class="ml-1 text-primary">{{
                        latestSupportiveInfo.has_allergy_from_blood_previously
                          .key
                      }}</span>
                    </h4>
                    <h5
                      class="ml-1 mb-1 text-primary"
                      v-if="
                        latestSupportiveInfo.has_allergy_from_blood_previously
                          .key == 'Yes'
                      "
                    >
                      - It is :
                      <span class="ml-1 text-primary">
                        {{
                          latestSupportiveInfo.has_allergy_from_blood_previously
                            .value
                        }}
                      </span>
                    </h5>
                  </div>
                  <br /><br />
                  <div>
                    <h4 class="ml-1 mb-1">
                      has allergy from blood component previously?
                      <span
                        v-if="latestSupportiveInfo.is_received_irradiated"
                        class="ml-1 text-primary"
                        >Yes</span
                      >
                      <span
                        v-if="!latestSupportiveInfo.is_received_irradiated"
                        class="ml-1 text-primary"
                        >No</span
                      >
                    </h4>
                  </div>
                  <br /><br />
                  <div style="flex: 1 1 500px">
                    <table style="margin-left: 2rem; width: 40%">
                      <tr>
                        <td style="width: 25%; height: 4rem" class="ml-3 h5">
                          Hb =
                        </td>
                        <td style="width: 75%">
                          <span class="font-weight-bolder text-primary"
                            >{{ this.latestSupportiveInfo.hb }}
                          </span>
                          <span style="min-width: 20%">g/dl</span> (before
                          receiving blood)
                        </td>
                      </tr>
                      <tr>
                        <td style="width: 25%; height: 4rem" class="ml-3 h5">
                          PLT =
                        </td>
                        <td style="width: 75%">
                          <span class="font-weight-bolder text-primary"
                            >{{ this.latestSupportiveInfo.plt }}
                          </span>
                          <span style="min-width: 20%">10<sup>9</sup>/L</span>
                          (before receiving plt)
                        </td>
                      </tr>
                    </table>
                  </div>
                  <br /><br />
                  <div>
                    <h4 class="ml-1 mb-1">Any complication if occurred :</h4>
                    <div
                      style="
                        margin-left: 2.5rem;
                        margin-top: 2rem;
                        max-width: 70%;
                      "
                    >
                      <h5 class="section-visit ml-1 text-primary">
                        {{ latestSupportiveInfo.description }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(11)">
          <b-col>
            <b-card v-if="pharmacyLoading">
              <template>
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
            </b-card>
            <b-card v-if="!pharmacyLoading">
              <div v-if="!pharmacyInfo && !pharmacyLoading">
                <h3>This Patient has No Pharmacy Presecriptions Available</h3>
              </div>
              <table v-if="pharmacyInfo" class="edit-drugs-table">
                <tr>
                  <td style="width: 15px">No</td>
                  <td style="width: 80px">Drug Scientific Name</td>
                  <td style="width: 80px">Drug Brand Name</td>
                  <td style="width: 40px">Dose</td>
                  <td style="width: 40px">QTY</td>
                  <td>Notes</td>
                  <td style="width: 30px">Source</td>
                  <td style="width: 30px">Date</td>
                </tr>
                <tr v-for="(i, index) in pharmacyInfo" :key="index">
                  <td style="width: 15px" class="">{{ index + 1 }}</td>
                  <td>
                    {{ i.drug_scientific_name.name }}
                  </td>
                  <td>
                    {{ i.drug.name }}
                  </td>
                  <td v-if="i.drug_information">
                    {{ i.drug_information.dose + "" + i.drug_information.unit }}
                  </td>
                  <td>
                    {{ i.quantity }}
                  </td>
                  <td>
                    {{ i.notes }}
                  </td>
                  <td>
                    {{ i.is_external ? "External" : "Internal" }}
                  </td>
                  <td>
                    {{ i.created_at }}
                  </td>
                </tr>
              </table>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(12)">
          <b-col>
            <b-card v-if="labLoading">
              <template>
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner label="Loading..." />
                  </div>
                </div>
              </template>
            </b-card>
            <b-card v-if="!labLoading">
              <div v-if="!labInfo && !labLoading">
                <h3>This Patient has No Lab Test Available</h3>
              </div>
              <table v-if="labInfo" class="edit-drugs-table">
                <tr>
                  <td>Name</td>
                  <td>Result</td>
                  <td>Normal Range</td>
                  <td>Result As To Normal Range</td>
                </tr>
                <tr v-for="(i, index) in labInfo" :key="index">
                  <td>
                    {{ i.name }}
                  </td>
                  <td>
                    {{ i.result }}
                  </td>
                  <td>
                    {{ i.normalRange }}
                  </td>
                  <td>
                    {{ i.resultAsToNormalRange }}
                  </td>
                </tr>
              </table>
            </b-card>
          </b-col>
        </b-row>
        <b-row v-if="itemClickedList.includes(13)">
          <b-col>
            <b-card v-if="assessmentLoading">
              <template>
                <div>
                  <div class="d-flex justify-content-center mb-1">
                    <b-spinner assessmentel="Loading..." />
                  </div>
                </div>
              </template>
            </b-card>
            <b-card v-if="!assessmentLoading">
              <div v-if="!assessmentInfo.length && !assessmentLoading">
                <h3>This Patient has No Assessment Available</h3>
              </div>
              <table v-if="assessmentInfo.length" class="edit-drugs-table">
                <tr style="font-weight: 900">
                  <td>Protocol Name</td>
                  <td>Goal of Assessment</td>
                  <td>Type of Response</td>
                  <td>Second step</td>
                  <td>Date</td>
                </tr>
                <tr v-for="(i, index) in assessmentInfo" :key="index">
                  <td>
                   <span v-if="i.treatment">{{ i.treatment.protocol.title }}</span> 
                   <span v-if="i.relapse">{{ i.relapse.protocol.title }}</span> 
                  </td>
                  <td>
                    {{ i.goal_of_assesment }}
                  </td>
                  <td>
                    {{ i.type_of_response }}
                  </td>
                  <td>
                    {{ i.second_step }}
                  </td>
                  <td>
                    {{ i.created_at }}
                  </td>
                </tr>
              </table>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="false"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename="patient card"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2PdfAll"
      >
        <section class="pdf-content font-modify" slot="pdf-content">
          <div class="html2pdf__page-break">
            <b-row>
              <b-col>
                <b-card>
                  <template v-if="patientDataLoading">
                    <div>
                      <div class="d-flex justify-content-center mb-1">
                        <b-spinner label="Loading..." />
                      </div>
                    </div>
                  </template>
                  <div v-if="!patientDataLoading" class="pb-0">
                    <div
                      class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0"
                    >
                      <!-- Header: Left Content -->
                      <div>
                        <h2 class="mb-2">Patient Details:</h2>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">Patient Name:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              <span v-if="patientData.first_name">
                                {{ patientData.first_name + " " }}</span
                              >
                              <span v-if="patientData.second_name">
                                {{ patientData.second_name + " " }}</span
                              >
                              <span v-if="patientData.third_name">
                                {{ patientData.third_name + " " }}</span
                              >
                              <span v-if="patientData.forth_name">
                                {{ patientData.forth_name + " " }}</span
                              >
                              <span v-if="patientData.nickname">
                                {{ patientData.nickname }}</span
                              >
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">Patient Age:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              {{ patientData.age }}
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">Mother Name:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              <span v-if="patientData.first_mother_name">{{
                                patientData.first_mother_name + " "
                              }}</span>
                              <span v-if="patientData.second_mother_name">{{
                                patientData.second_mother_name + " "
                              }}</span>
                              <span v-if="patientData.third_mother_name">{{
                                patientData.third_mother_name + " "
                              }}</span>
                              <span v-if="patientData.forth_mother_name">{{
                                patientData.forth_mother_name
                              }}</span>
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">Main Phone Number:</h5>
                          </b-col>
                          <b-col class="mr-4" cols="auto">
                            <h5 class="font-weight-bold">
                              {{ patientData.phone }}
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">2nd Phone Number:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              {{ patientData.second_phone }}
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">Address:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              {{ cities[this.patientData.city_id - 1] }},
                              {{ patientData.adderss }}
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">National ID:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              {{ patientData.national_id }}
                              <span v-if="patientData.card_type"
                                >, (<span>{{ patientData.card_type }}</span
                                >)</span
                              >
                            </h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold"></h5>
                          </b-col>
                        </b-row>
                        <b-row class="mb-75">
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">Gender:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              {{ patientData.gender }}
                            </h5>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">Referral:</h5>
                          </b-col>
                          <b-col cols="auto">
                            <h5 class="font-weight-bold">
                              {{ patientData.patient_referred_from }}
                            </h5>
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                    <br />
                  </div>
                </b-card>
              </b-col>
            </b-row>
          </div>
          <!-- First Visit -->
          <b-row v-if="itemClickedList.includes(0)">
            <b-col>
              <div class="html2pdf__page-break">
                <b-card>
                  <template v-if="firstVisitLoading">
                    <div>
                      <div class="d-flex justify-content-center mb-1">
                        <b-spinner label="Loading..." />
                      </div>
                    </div>
                  </template>
                  <div v-if="!itemsField && !firstVisitLoading">
                    <h3>This Patient has No First Visit Available</h3>
                  </div>
                  <div v-if="itemsField && !firstVisitLoading">
                    <h2>First Visit :</h2>
                    <div>
                      <b-row class="visit-row">
                        <b-col cols="6">
                          <div class="section-visit">
                            <h3>Presenting Symptom :</h3>
                            <ul>
                              <div v-if="itemsField.presenting_Symptom.default">
                                <li
                                  v-for="item in itemsField.presenting_Symptom
                                    .default"
                                  v-bind:key="item"
                                >
                                  {{ item }}
                                </li>
                              </div>
                              <li v-if="itemsField.presenting_Symptom.bleeding">
                                bleeding
                                <ul
                                  v-for="item in itemsField.presenting_Symptom
                                    .bleeding"
                                  v-bind:key="item"
                                >
                                  <li>{{ item }}</li>
                                </ul>
                              </li>
                              <li
                                v-if="itemsField.presenting_Symptom.infection"
                              >
                                infection :
                                {{ itemsField.presenting_Symptom.infection }}
                              </li>
                            </ul>
                          </div>
                          <div class="section-visit">
                            <h3>Peformance State :</h3>
                            <li v-if="itemsField.peformance_state">
                              <span class="mx-25 text-primary font-weight-bold">
                              </span
                              >{{ itemsField.peformance_state }}
                            </li>
                          </div>
                          <div class="section-visit">
                            <h3>Initial Investigation Before Admission :</h3>
                            <ul>
                              <li
                                class="mb-2"
                                v-if="
                                  itemsField
                                    .initial_investigation_before_admission.cbc
                                "
                              >
                                <span class="font-weight-bold">CBC</span>
                                <span
                                  style="float: right"
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_cbcList
                                  "
                                  >Date:
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_cbcList
                                  }}</span
                                >
                                <table class="firstVisit-table mt-75">
                                  <tr>
                                    <td>WBC</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .cbc.wbc
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .cbc.wbc
                                          : ""
                                      }}
                                    </td>
                                    <td>N%</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .cbc.n
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .cbc.n
                                          : ""
                                      }}
                                    </td>
                                    <td>L%</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .cbc.l
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .cbc.l
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>Hb</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .cbc.hb
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .cbc.hb
                                          : ""
                                      }}
                                    </td>
                                    <td>Plt</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .cbc.plt
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .cbc.plt
                                          : ""
                                      }}
                                    </td>
                                    <td>Blast%</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .cbc.blast
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .cbc.blast
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                </table>
                              </li>
                              <li
                                class="mb-2"
                                v-if="
                                  itemsField
                                    .initial_investigation_before_admission
                                    .biochemistry
                                "
                              >
                                <span class="font-weight-bold"
                                  >Biochemistry</span
                                >
                                <span
                                  style="float: right"
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_admissionBiochemistryList
                                  "
                                  >Date:
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_admissionBiochemistryList
                                  }}</span
                                >
                                <table class="firstVisit-table">
                                  <tr>
                                    <td>B urea</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.b_urea
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.b_urea
                                          : ""
                                      }}
                                    </td>
                                    <td>S crea</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.s_crea
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.s_crea
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>S ca</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.s_ca
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.s_ca
                                          : ""
                                      }}
                                    </td>
                                    <td>Uric acid</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.uric_acid
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.uric_acid
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>ALT</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.alt
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.alt
                                          : ""
                                      }}
                                    </td>
                                    <td>AST</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.ast
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.ast
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>ALP</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.alp
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.alp
                                          : ""
                                      }}
                                    </td>
                                    <td>TSB</td>
                                    <td>
                                      {{
                                        itemsField
                                          .initial_investigation_before_admission
                                          .biochemistry.tsb
                                          ? itemsField
                                              .initial_investigation_before_admission
                                              .biochemistry.tsb
                                          : ""
                                      }}
                                    </td>
                                  </tr>
                                </table>
                              </li>
                              <li
                                class="my-3"
                                v-if="
                                  itemsField
                                    .initial_investigation_before_admission
                                    .ultra_sound.Presence_of_Hepatomegaly ||
                                  itemsField
                                    .initial_investigation_before_admission
                                    .ultra_sound.Presence_of_splenomegaly ||
                                  itemsField
                                    .initial_investigation_before_admission
                                    .ultra_sound.Presence_of_LNpathy
                                "
                              >
                                <span class="font-weight-bold"
                                  >Ultra Sound</span
                                >
                                <span
                                  style="float: right"
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_ultra_soundList
                                  "
                                  >Date:
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_ultra_soundList
                                  }}</span
                                >
                                <ul>
                                  <li
                                    v-if="
                                      itemsField
                                        .initial_investigation_before_admission
                                        .ultra_sound.Presence_of_Hepatomegaly
                                    "
                                  >
                                    Presence of Hepatomegaly
                                  </li>
                                  <li
                                    v-if="
                                      itemsField
                                        .initial_investigation_before_admission
                                        .ultra_sound.Presence_of_splenomegaly
                                    "
                                  >
                                    Presence of Splenomegaly
                                  </li>
                                  <li
                                    v-if="
                                      itemsField
                                        .initial_investigation_before_admission
                                        .ultra_sound.Presence_of_LNpathy
                                    "
                                  >
                                    Presence of LNpathy :
                                    {{
                                      itemsField
                                        .initial_investigation_before_admission
                                        .ultra_sound.Presence_of_LNpathy
                                    }}
                                  </li>
                                </ul>
                              </li>
                              <li
                                class="my-3"
                                v-if="
                                  itemsField
                                    .initial_investigation_before_admission
                                    .chest_x_ray
                                "
                              >
                                <span class="font-weight-bold"
                                  >Chest X Ray :
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .chest_x_ray
                                  }}</span
                                >
                                <span
                                  style="float: right"
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_chest_x_rayList
                                  "
                                  >Date:
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_chest_x_rayList
                                  }}</span
                                >
                              </li>
                              <li
                                v-if="
                                  itemsField
                                    .initial_investigation_before_admission
                                    .blood_film
                                "
                              >
                                <span class="font-weight-bold">{{
                                  itemsField
                                    .initial_investigation_before_admission
                                    .blood_film
                                }}</span>
                                <span
                                  style="float: right"
                                  v-if="
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_blood_film_input
                                  "
                                  >Date:
                                  {{
                                    itemsField
                                      .initial_investigation_before_admission
                                      .dateValue_blood_film_input
                                  }}</span
                                >
                              </li>
                            </ul>
                          </div>
                          <div class="section-visit">
                            <h3>On Examination :</h3>
                            <ul>
                              <li v-if="itemsField.on_examination.general_look">
                                General Look :
                                {{ itemsField.on_examination.general_look }}
                              </li>
                              <li
                                v-if="
                                  itemsField.on_examination.general_examination
                                "
                              >
                                General Examination
                                <ul
                                  v-for="item in itemsField.on_examination
                                    .general_examination"
                                  v-bind:key="item"
                                >
                                  <li>{{ item }}</li>
                                </ul>
                              </li>
                              <li
                                v-if="
                                  itemsField.on_examination.chest_examination
                                "
                              >
                                Chest Examination :
                                {{
                                  itemsField.on_examination.chest_examination
                                }}
                              </li>
                              <li
                                v-if="
                                  itemsField.on_examination
                                    .abdominal_examination
                                "
                              >
                                Abdominal Examination :
                                {{
                                  itemsField.on_examination
                                    .abdominal_examination
                                }}
                              </li>
                              <li
                                v-if="
                                  itemsField.on_examination
                                    .neurological_examination
                                "
                              >
                                Neurological Examination :
                                {{
                                  itemsField.on_examination
                                    .neurological_examination
                                }}
                              </li>
                            </ul>
                          </div>
                        </b-col>
                        <b-col cols="6">
                          <div class="section-visit">
                            <h3>Investigation Send :</h3>
                            <ul>
                              <li
                                v-if="itemsField.investigation_send.cytogenetic"
                              >
                                Cytogenetic
                              </li>
                              <li
                                v-if="itemsField.investigation_send.molecular"
                              >
                                Molecular
                              </li>
                              <li
                                v-if="itemsField.investigation_send.hematology"
                              >
                                Hematology
                                <ul
                                  v-for="item in itemsField.investigation_send
                                    .hematology"
                                  v-bind:key="item"
                                >
                                  <li>{{ item }}</li>
                                </ul>
                              </li>
                              <li v-if="itemsField.investigation_send.virology">
                                Virology
                                <ul
                                  v-for="item in itemsField.investigation_send
                                    .virology"
                                  v-bind:key="item"
                                >
                                  <li>{{ item }}</li>
                                </ul>
                              </li>
                              <li
                                v-if="itemsField.investigation_send.immunology"
                              >
                                Immunology
                                <ul
                                  v-for="item in itemsField.investigation_send
                                    .immunology"
                                  v-bind:key="item"
                                >
                                  <li>{{ item }}</li>
                                </ul>
                              </li>
                              <li v-if="itemsField.investigation_send.hormonal">
                                Hormonal
                                <ul
                                  v-for="item in itemsField.investigation_send
                                    .hormonal"
                                  v-bind:key="item"
                                >
                                  <li>{{ item }}</li>
                                </ul>
                              </li>
                              <li
                                v-if="itemsField.investigation_send.radiology"
                              >
                                Radiology
                                <ul
                                  v-for="item in itemsField.investigation_send
                                    .radiology"
                                  v-bind:key="item"
                                >
                                  <li>{{ item }}</li>
                                </ul>
                              </li>
                            </ul>
                          </div>
                          <div class="section-visit">
                            <h3>Road Map :</h3>
                            <ul>
                              <li v-if="itemsField.road_map">
                                {{ itemsField.road_map }}
                              </li>
                            </ul>
                          </div>
                          <div class="section-visit">
                            <h3>Senior Impression :</h3>
                            <ul>
                              <li v-if="itemsField.senior_impression">
                                {{ itemsField.senior_impression }}
                              </li>
                            </ul>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(1)">
            <b-col>
              <b-card>
                <template v-if="loadDiagnosis">
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
                <div v-if="!Latestdiagnosis && !loadDiagnosis">
                  <h3>This Patient has no Diagnosis Available</h3>
                </div>
                <div v-if="Latestdiagnosis && !loadDiagnosis">
                  <h2>Latest Diagnosis :</h2>
                  <br />
                  <b-row>
                    <b-col>
                      <div>
                        <h3>- {{ Latestdiagnosis }}</h3>
                      </div>
                    </b-col>
                  </b-row>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(2)">
            <b-col>
              <div class="html2pdf__page-break">
                <b-card>
                  <template v-if="loadPrognosis">
                    <div>
                      <div class="d-flex justify-content-center mb-1">
                        <b-spinner label="Loading..." />
                      </div>
                    </div>
                  </template>
                  <div v-if="!Latestdiagnosis && !loadPrognosis">
                    <h3>This Patient has no Risk Stratification Available</h3>
                  </div>
                  <div v-if="Latestdiagnosis && !loadPrognosis">
                    <b-row>
                      <b-col cols="12">
                        <h2>
                          Risk Stratification for
                          <span style="color: blue">{{ Latestdiagnosis }}</span>
                        </h2>
                      </b-col>
                      <b-col cols="12"><br /><br /></b-col>
                      <b-col lg="12" xl="12">
                        <b-card
                          class="Risk_bg"
                          style="border-bottom: 3px solid rgb(25, 0, 255)"
                        >
                          <div v-for="(item, index) in patienPrognosisInfo">
                            <h4
                              v-if="
                                index != 'id' &&
                                index != 'created_at' &&
                                index != 'updated_at' &&
                                index != 'result' &&
                                index != 'patient_disease_id' &&
                                index != 'outCome' &&
                                index != 'score'
                              "
                              class="pb-75"
                            >
                              <b-row>
                                <b-col>
                                  <span
                                    v-if="
                                      prognosisTitle != 'ALL' ||
                                      index != 'cytogenetic'
                                    "
                                    >{{ index.replaceAll("_", " ") }}</span
                                  >
                                </b-col>
                                <b-col class="border-left">
                                  <span
                                    v-if="
                                      prognosisTitle != 'ALL' ||
                                      index != 'cytogenetic'
                                    "
                                    >{{ item }}</span
                                  >
                                </b-col>
                              </b-row>
                            </h4>
                            <!-- special output for ALL prognosis -->
                            <!-- TODO: Can be solve in less code if we did not get an object in the prognosis result -->
                            <div
                              v-if="
                                prognosisTitle == 'ALL' &&
                                (index == 'cytogenetic' || index == 'result')
                              "
                            >
                              <h4 class="pb-75">
                                <b-row
                                  class="modify_result_display_div"
                                  v-if="
                                    prognosisTitle == 'ALL' && index == 'result'
                                  "
                                  style="
                                    color: rgb(255, 255, 255);
                                    margin-top: 1rem;
                                  "
                                >
                                  <b-col>
                                    <span
                                      v-if="
                                        prognosisTitle != 'ALL' ||
                                        index != 'cytogenetic'
                                      "
                                      >{{ index.replaceAll("_", " ") }}</span
                                    >
                                  </b-col>
                                  <b-col class="border-left">
                                    <span
                                      v-if="
                                        prognosisTitle != 'ALL' ||
                                        index != 'cytogenetic'
                                      "
                                      >{{ item }}</span
                                    >
                                  </b-col>
                                </b-row>
                                <b-row
                                  v-if="
                                    prognosisTitle == 'ALL' &&
                                    index == 'cytogenetic'
                                  "
                                  style="margin-top: 1rem"
                                >
                                  <b-col
                                    v-if="
                                      prognosisTitle == 'ALL' &&
                                      index == 'cytogenetic'
                                    "
                                  >
                                    {{
                                      Object.keys(item)[0].replaceAll("_", " ")
                                    }}
                                  </b-col>
                                  <b-col
                                    v-if="
                                      prognosisTitle == 'ALL' &&
                                      index == 'cytogenetic'
                                    "
                                    class="border-left"
                                  >
                                    {{ item[Object.keys(item)[0]] }}
                                  </b-col>
                                </b-row>
                                <b-row
                                  v-if="
                                    prognosisTitle == 'ALL' &&
                                    index == 'cytogenetic'
                                  "
                                  style="margin-top: 2.5rem"
                                >
                                  <b-col
                                    style="margin: auto; display: block"
                                    v-if="
                                      prognosisTitle == 'ALL' &&
                                      index == 'cytogenetic'
                                    "
                                  >
                                    <span>{{
                                      Object.keys(item)[1].replaceAll("_", " ")
                                    }}</span>
                                  </b-col>
                                  <b-col
                                    v-if="
                                      prognosisTitle == 'ALL' &&
                                      index == 'cytogenetic'
                                    "
                                    class="border-left"
                                  >
                                    <span
                                      style="margin-top: 1.5rem; display: block"
                                      v-for="listItem in item[
                                        Object.keys(item)[1]
                                      ]"
                                      >{{ listItem }}</span
                                    >
                                  </b-col>
                                </b-row>
                              </h4>
                            </div>
                            <div
                              :class="[
                                prognosisTitle == 'ALL' ? 'ALL-style' : '',
                                'modify_result_display_div',
                              ]"
                              v-if="
                                prognosisTitle != 'ALL' &&
                                (index == 'result' ||
                                  index == 'outCome' ||
                                  index == 'score')
                              "
                            >
                              <h4 class="modify_result_display">
                                <div>
                                  <span class="pr-2" v-if="index == 'result'">
                                    Result</span
                                  >
                                  <span class="pl-2" v-if="index == 'result'"
                                    >: {{ item }}</span
                                  >
                                </div>
                                <div>
                                  <span class="pr-2" v-if="index == 'score'"
                                    >Score</span
                                  >
                                  <span class="pl-2" v-if="index == 'score'"
                                    >: {{ item }}</span
                                  >
                                </div>
                                <div>
                                  <span class="pr-2" v-if="index == 'outCome'">
                                    OutCome
                                  </span>
                                  <span class="pl-2" v-if="index == 'outCome'"
                                    >: [ PFS : {{ item.PFS }} -- OS :
                                    {{ item.OS }} ]
                                  </span>
                                </div>
                              </h4>
                            </div>
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(3)">
            <b-col>
              <div class="html2pdf__page-break">
                <b-card>
                  <template v-if="treatmentLoading">
                    <div>
                      <div class="d-flex justify-content-center mb-1">
                        <b-spinner label="Loading..." />
                      </div>
                    </div>
                  </template>
                  <div v-if="!treatmentForPatient && !treatmentLoading">
                    <h3>This Patient has no Active Treatment Available</h3>
                  </div>
                  <div v-if="treatmentForPatient && !treatmentLoading">
                    <b-card>
                      <div>
                        <h3>Chemotherapy Re-constitution Form</h3>
                      </div>
                      <b-row>
                        <b-col cols="12">
                          <div v-if="!treatmentLoading">
                            <div class="mt-2">
                              <table class="patient-table">
                                <tr>
                                  <td>
                                    Patient Name :
                                    <span class="font-weight-bold">
                                      <span v-if="patientData.first_name">{{
                                        patientData.first_name + " "
                                      }}</span>
                                      <span v-if="patientData.second_name">{{
                                        patientData.second_name + " "
                                      }}</span>
                                      <span v-if="patientData.third_name">{{
                                        patientData.third_name + " "
                                      }}</span>
                                      <span v-if="patientData.forth_name">{{
                                        patientData.forth_name
                                      }}</span>
                                    </span>
                                  </td>
                                  <td>
                                    Age :
                                    <span class="font-weight-bold">
                                      {{ patientData.age }}</span
                                    >
                                  </td>
                                  <td>BSA :</td>
                                </tr>
                                <tr>
                                  <td colspan="2">
                                    Name of specialist :
                                    <span class="font-weight-bold">
                                      {{
                                        treatmentForPatient.name_of_specialist
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Date :
                                    <span class="font-weight-bold">
                                      {{ treatmentForPatient.created_at }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Diagnosis :
                                    <span class="font-weight-bold">
                                      {{ treatmentForPatient.daignosis }}</span
                                    >
                                  </td>
                                  <!-- <td>Protocol name :
																<span class="font-weight-bold"> {{
																	treatmentForPatient.protocol.title
																}}</span>
															</td> -->
                                  <td>
                                    Number of dose :
                                    <span class="font-weight-bold">
                                      {{
                                        treatmentForPatient.number_of_dose
                                      }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>Case sheet number :</td>
                                  <td>
                                    Room number :
                                    <span class="font-weight-bold">
                                      {{
                                        treatmentForPatient.room_number
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Gender :
                                    <span class="font-weight-bold">
                                      {{ patientData.gender }}</span
                                    >
                                  </td>
                                </tr>
                              </table>
                              <br />
                              <table class="drugs-table">
                                <tr>
                                  <td>No</td>
                                  <td>Drug</td>
                                  <td>Dose</td>
                                  <td>Diluted in</td>
                                  <td>Rout of administration</td>
                                  <td>Time to start administration</td>
                                  <td>Duration of administration</td>
                                  <td>Note</td>
                                </tr>
                                <tr
                                  v-for="i in treatmentForPatient.reconstitution_patient"
                                >
                                  <td class="">
                                    D
                                    <span>{{ i.from_day }}</span>
                                    <span v-if="i.to_day">/{{ i.to_day }}</span>
                                  </td>
                                  <td>{{ i.drug }}</td>
                                  <td>{{ i.dose }}</td>
                                  <td>{{ i.diluted_in }}</td>
                                  <td>{{ i.route_of_administration }}</td>
                                  <td v-if="i.time_to_start_administration">
                                    {{ i.time_to_start_administration }}
                                  </td>
                                  <td v-if="!i.time_to_start_administration">
                                    -
                                  </td>
                                  <td>{{ i.duration_of_administration }}</td>
                                  <td v-if="i.notes">{{ i.notes }}</td>
                                  <td v-if="!i.notes">-</td>
                                </tr>
                              </table>
                            </div>
                            <div class="mt-2">
                              <ul>
                                <li>
                                  This should be signed first by the
                                  hematologist, then the pharmacist, then the
                                  Re-constituter, and finally by the nurse.
                                </li>
                                <li>
                                  The nurse should compare this paper to what
                                  had been written in the case sheet, which
                                  should be 100% compatible.
                                </li>
                                <li>
                                  The premedication is not included, so the
                                  nurse should check the case sheet.
                                </li>
                              </ul>
                            </div>
                            <div class="my-5 mx-2">
                              <table class="sign-table">
                                <tr>
                                  <td>hematologist sign</td>
                                  <td>Pharmacist sign</td>
                                  <td>Re-constituter sign</td>
                                  <td>Nurse</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(4)">
            <b-col>
              <div class="html2pdf__page-break">
                <b-card>
                  <template v-if="latestTreatmentLoading">
                    <div>
                      <div class="d-flex justify-content-center mb-1">
                        <b-spinner label="Loading..." />
                      </div>
                    </div>
                  </template>
                  <div
                    v-if="!latestTreatmentLoading && !latestTreatmentForPatient"
                  >
                    <h3>This Patient has No Latest Treatment Available</h3>
                  </div>
                  <div
                    v-if="!latestTreatmentLoading && latestTreatmentForPatient"
                  >
                    <b-card>
                      <div v-if="!latestTreatmentLoading">
                        <h3>Chemotherapy Re-constitution Form</h3>
                      </div>
                      <b-row>
                        <b-col cols="12">
                          <div v-if="!latestTreatmentLoading">
                            <div class="mt-2">
                              <table class="patient-table">
                                <tr>
                                  <td>
                                    Patient Name :
                                    <span class="font-weight-bold">
                                      <span v-if="patientData.first_name">{{
                                        patientData.first_name + " "
                                      }}</span>
                                      <span v-if="patientData.second_name">{{
                                        patientData.second_name + " "
                                      }}</span>
                                      <span v-if="patientData.third_name">{{
                                        patientData.third_name + " "
                                      }}</span>
                                      <span v-if="patientData.forth_name">{{
                                        patientData.forth_name
                                      }}</span>
                                    </span>
                                  </td>
                                  <td>
                                    Age :
                                    <span class="font-weight-bold">
                                      {{ patientData.age }}</span
                                    >
                                  </td>
                                  <td>BSA :</td>
                                </tr>
                                <tr>
                                  <td colspan="2">
                                    Name of specialist :
                                    <span class="font-weight-bold">
                                      {{
                                        latestTreatmentForPatient.name_of_specialist
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Date :
                                    <span class="font-weight-bold">
                                      {{
                                        latestTreatmentForPatient.created_at
                                      }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Diagnosis :
                                    <span class="font-weight-bold">
                                      {{
                                        latestTreatmentForPatient.daignosis
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Protocol name :
                                    <span class="font-weight-bold">
                                      {{
                                        latestTreatmentForPatient.protocol.title
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Number of dose :
                                    <span class="font-weight-bold">
                                      {{
                                        latestTreatmentForPatient.number_of_dose
                                      }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>Case sheet number :</td>
                                  <td>
                                    Room number :
                                    <span class="font-weight-bold">
                                      {{
                                        latestTreatmentForPatient.room_number
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Gender :
                                    <span class="font-weight-bold">
                                      {{ patientData.gender }}</span
                                    >
                                  </td>
                                </tr>
                              </table>
                              <br />
                              <table class="drugs-table">
                                <tr>
                                  <td>No</td>
                                  <td>Drug</td>
                                  <td>Dose</td>
                                  <td>Diluted in</td>
                                  <td>Rout of administration</td>
                                  <td>Time to start administration</td>
                                  <td>Duration of administration</td>
                                  <td>Note</td>
                                </tr>
                                <tr
                                  v-for="i in latestTreatmentForPatient.reconstitution_patient"
                                >
                                  <td class="">
                                    D
                                    <span>{{ i.from_day }}</span>
                                    <span v-if="i.to_day">/{{ i.to_day }}</span>
                                  </td>
                                  <td>{{ i.drug }}</td>
                                  <td>{{ i.dose }}</td>
                                  <td>{{ i.diluted_in }}</td>
                                  <td>{{ i.route_of_administration }}</td>
                                  <td v-if="i.time_to_start_administration">
                                    {{ i.time_to_start_administration }}
                                  </td>
                                  <td v-if="!i.time_to_start_administration">
                                    -
                                  </td>
                                  <td>{{ i.duration_of_administration }}</td>
                                  <td v-if="i.notes">{{ i.notes }}</td>
                                  <td v-if="!i.notes">-</td>
                                </tr>
                              </table>
                            </div>
                            <div class="mt-2">
                              <ul>
                                <li>
                                  This should be signed first by the
                                  hematologist, then the pharmacist, then the
                                  Re-constituter, and finally by the nurse.
                                </li>
                                <li>
                                  The nurse should compare this paper to what
                                  had been written in the case sheet, which
                                  should be 100% compatible.
                                </li>
                                <li>
                                  The premedication is not included, so the
                                  nurse should check the case sheet.
                                </li>
                              </ul>
                            </div>
                            <div class="my-5 mx-2">
                              <table class="sign-table">
                                <tr>
                                  <td>hematologist sign</td>
                                  <td>Pharmacist sign</td>
                                  <td>Re-constituter sign</td>
                                  <td>Nurse</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(5)">
            <b-col>
              <div class="html2pdf__page-break">
                <b-card>
                  <template v-if="relapseLoading">
                    <div>
                      <div class="d-flex justify-content-center mb-1">
                        <b-spinner label="Loading..." />
                      </div>
                    </div>
                  </template>
                  <div v-if="!relapseForPatient && !relapseLoading">
                    <h3>
                      This Patient has No Active Relapse Protocol Available
                    </h3>
                  </div>
                  <div v-if="relapseForPatient && !relapseLoading">
                    <b-card>
                      <div>
                        <h3>Chemotherapy Re-constitution Form</h3>
                      </div>
                      <b-row>
                        <b-col cols="12">
                          <div>
                            <div class="mt-2">
                              <table class="patient-table">
                                <tr>
                                  <td>
                                    Patient Name :
                                    <span class="font-weight-bold">
                                      <span v-if="patientData.first_name">{{
                                        patientData.first_name + " "
                                      }}</span>
                                      <span v-if="patientData.second_name">{{
                                        patientData.second_name + " "
                                      }}</span>
                                      <span v-if="patientData.third_name">{{
                                        patientData.third_name + " "
                                      }}</span>
                                      <span v-if="patientData.forth_name">{{
                                        patientData.forth_name
                                      }}</span>
                                    </span>
                                  </td>
                                  <td>
                                    Age :
                                    <span class="font-weight-bold">
                                      {{ patientData.age }}</span
                                    >
                                  </td>
                                  <td>BSA :</td>
                                </tr>
                                <tr>
                                  <td colspan="2">
                                    Name of specialist :
                                    <span class="font-weight-bold">
                                      {{
                                        relapseForPatient.name_of_specialist
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Date :
                                    <span class="font-weight-bold">
                                      {{ relapseForPatient.created_at }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Diagnosis :
                                    <span class="font-weight-bold">
                                      {{ relapseForPatient.daignosis }}</span
                                    >
                                    <!--  DiseaseCategory[relapseForPatient.protocol.disease_category_id-1] -->
                                  </td>
                                  <!-- <td>Protocol name :
																<span class="font-weight-bold"> {{
																	relapseForPatient.protocol.title
																}}</span>
															</td> -->
                                  <td>
                                    Number of dose :
                                    <span class="font-weight-bold">
                                      {{
                                        relapseForPatient.number_of_dose
                                      }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>Case sheet number :</td>
                                  <td>
                                    Room number :
                                    <span class="font-weight-bold">
                                      {{ relapseForPatient.room_number }}</span
                                    >
                                  </td>
                                  <td>
                                    Gender :
                                    <span class="font-weight-bold">
                                      {{ patientData.gender }}</span
                                    >
                                  </td>
                                </tr>
                              </table>
                              <br />
                              <table class="drugs-table">
                                <tr>
                                  <td>No</td>
                                  <td>Drug</td>
                                  <td>Dose</td>
                                  <td>Diluted in</td>
                                  <td>Rout of administration</td>
                                  <td>Time to start administration</td>
                                  <td>Duration of administration</td>
                                  <td>Note</td>
                                </tr>
                                <tr
                                  v-for="i in relapseForPatient.reconstitution_patient"
                                >
                                  <td class="">
                                    D
                                    <span>{{ i.from_day }}</span>
                                    <span v-if="i.to_day">/{{ i.to_day }}</span>
                                  </td>
                                  <td>{{ i.drug }}</td>
                                  <td>{{ i.dose }}</td>
                                  <td>{{ i.diluted_in }}</td>
                                  <td>{{ i.route_of_administration }}</td>
                                  <td v-if="i.time_to_start_administration">
                                    {{ i.time_to_start_administration }}
                                  </td>
                                  <td v-if="!i.time_to_start_administration">
                                    -
                                  </td>
                                  <td>{{ i.duration_of_administration }}</td>
                                  <td v-if="i.notes">{{ i.notes }}</td>
                                  <td v-if="!i.notes">-</td>
                                </tr>
                              </table>
                            </div>
                            <div class="mt-2">
                              <ul>
                                <li>
                                  This should be signed first by the
                                  hematologist, then the pharmacist, then the
                                  Re-constituter, and finally by the nurse.
                                </li>
                                <li>
                                  The nurse should compare this paper to what
                                  had been written in the case sheet, which
                                  should be 100% compatible.
                                </li>
                                <li>
                                  The premedication is not included, so the
                                  nurse should check the case sheet.
                                </li>
                              </ul>
                            </div>
                            <div class="my-5 mx-2">
                              <table class="sign-table">
                                <tr>
                                  <td>hematologist sign</td>
                                  <td>Pharmacist sign</td>
                                  <td>Re-constituter sign</td>
                                  <td>Nurse</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(6)">
            <b-col>
              <div class="html2pdf__page-break">
                <b-card>
                  <template v-if="latestRelapseLoading">
                    <div>
                      <div class="d-flex justify-content-center mb-1">
                        <b-spinner label="Loading..." />
                      </div>
                    </div>
                  </template>
                  <div v-if="!latestRelapseForPatient && !latestRelapseLoading">
                    <h3>
                      This Patient has No Latest Relapse Protocol Available
                    </h3>
                  </div>
                  <div>
                    <b-card
                      v-if="latestRelapseForPatient && !latestRelapseLoading"
                    >
                      <div>
                        <h3>Chemotherapy Re-constitution Form</h3>
                      </div>
                      <b-row>
                        <b-col cols="12">
                          <div>
                            <div class="mt-2">
                              <table class="patient-table">
                                <tr>
                                  <td>
                                    Patient Name :
                                    <span class="font-weight-bold">
                                      <span v-if="patientData.first_name">{{
                                        patientData.first_name + " "
                                      }}</span>
                                      <span v-if="patientData.second_name">{{
                                        patientData.second_name + " "
                                      }}</span>
                                      <span v-if="patientData.third_name">{{
                                        patientData.third_name + " "
                                      }}</span>
                                      <span v-if="patientData.forth_name">{{
                                        patientData.forth_name
                                      }}</span>
                                    </span>
                                  </td>
                                  <td>
                                    Age :
                                    <span class="font-weight-bold">
                                      {{ patientData.age }}</span
                                    >
                                  </td>
                                  <td>BSA :</td>
                                </tr>
                                <tr>
                                  <td colspan="2">
                                    Name of specialist :
                                    <span class="font-weight-bold">
                                      {{
                                        latestRelapseForPatient.name_of_specialist
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Date :
                                    <span class="font-weight-bold">
                                      {{
                                        latestRelapseForPatient.created_at
                                      }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Diagnosis :
                                    <span class="font-weight-bold">
                                      {{
                                        latestRelapseForPatient.daignosis
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Protocol name :
                                    <!-- <span class="font-weight-bold"> {{
																	latestRelapseForPatient.protocol.title
																}}</span> -->
                                  </td>
                                  <td>
                                    Number of dose :
                                    <span class="font-weight-bold">
                                      {{
                                        latestRelapseForPatient.number_of_dose
                                      }}</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td>Case sheet number :</td>
                                  <td>
                                    Room number :
                                    <span class="font-weight-bold">
                                      {{
                                        latestRelapseForPatient.room_number
                                      }}</span
                                    >
                                  </td>
                                  <td>
                                    Gender :
                                    <span class="font-weight-bold">
                                      {{ patientData.gender }}</span
                                    >
                                  </td>
                                </tr>
                              </table>
                              <br />
                              <table class="drugs-table">
                                <tr>
                                  <td>No</td>
                                  <td>Drug</td>
                                  <td>Dose</td>
                                  <td>Diluted in</td>
                                  <td>Rout of administration</td>
                                  <td>Time to start administration</td>
                                  <td>Duration of administration</td>
                                  <td>Note</td>
                                </tr>
                                <tr
                                  v-for="i in latestRelapseForPatient.reconstitution_patient"
                                >
                                  <td class="">
                                    D
                                    <span>{{ i.from_day }}</span>
                                    <span v-if="i.to_day">/{{ i.to_day }}</span>
                                  </td>
                                  <td>{{ i.drug }}</td>
                                  <td>{{ i.dose }}</td>
                                  <td>{{ i.diluted_in }}</td>
                                  <td>{{ i.route_of_administration }}</td>
                                  <td v-if="i.time_to_start_administration">
                                    {{ i.time_to_start_administration }}
                                  </td>
                                  <td v-if="!i.time_to_start_administration">
                                    -
                                  </td>
                                  <td>{{ i.duration_of_administration }}</td>
                                  <td v-if="i.notes">{{ i.notes }}</td>
                                  <td v-if="!i.notes">-</td>
                                </tr>
                              </table>
                            </div>
                            <div class="mt-2">
                              <ul>
                                <li>
                                  This should be signed first by the
                                  hematologist, then the pharmacist, then the
                                  Re-constituter, and finally by the nurse.
                                </li>
                                <li>
                                  The nurse should compare this paper to what
                                  had been written in the case sheet, which
                                  should be 100% compatible.
                                </li>
                                <li>
                                  The premedication is not included, so the
                                  nurse should check the case sheet.
                                </li>
                              </ul>
                            </div>
                            <div class="my-5 mx-2">
                              <table class="sign-table">
                                <tr>
                                  <td>hematologist sign</td>
                                  <td>Pharmacist sign</td>
                                  <td>Re-constituter sign</td>
                                  <td>Nurse</td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </div>
                </b-card>
              </div>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(7)">
            <!-- Patient Consultation -->
            <b-col>
              <b-card>
                <template v-if="latestConsultationLoading">
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
                <div v-if="!latestConsultation && !latestConsultationLoading">
                  <h3>This Patient has No Latest Consultation Available</h3>
                </div>
                <div class="html2pdf__page-break">
                  <b-card-body
                    v-if="latestConsultation && !latestConsultationLoading"
                  >
                    <b-row>
                      <div>
                        <h2>Consultation</h2>
                        <br />
                        <b-row>
                          <b-col cols="6">
                            <div class="section-consultant">
                              <div>
                                <span class="h5">Date of Consultation : </span
                                ><span class="h5 text-muted">{{
                                  latestConsultation.date_of_consultation
                                }}</span>
                              </div>
                            </div>
                            <div class="section-consultant">
                              <div>
                                <span class="h5">Consulting Site : </span
                                ><span class="h5 text-primary">{{
                                  latestConsultation.consulting_site
                                }}</span>
                              </div>
                            </div>
                          </b-col>
                          <b-col cols="6">
                            <div class="section-consultant">
                              <div>
                                <span class="h5">Cause of Consultation : </span
                                ><span class="h5 text-primary">{{
                                  latestConsultation.cause_of_consultation
                                }}</span>
                              </div>
                            </div>
                            <div class="section-consultant">
                              <div>
                                <span class="h5">Management : </span
                                ><span class="h5 text-primary">{{
                                  latestConsultation.management
                                }}</span>
                              </div>
                            </div>
                          </b-col>
                          <!-- <b-col cols="12">
														<div class="section-consultant">
															<h3 class="pb-1">Consulting Paper File :</h3>
															<img class="modify-consulting-paper"
																:src="latestConsultation.consulting_paper_file" alt="">
														</div>
													</b-col> -->
                        </b-row>
                      </div>
                    </b-row>
                  </b-card-body>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(8)">
            <!-- Patient Emergency -->
            <b-col>
              <b-card>
                <template v-if="latestEmergencyLoading">
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
                <div v-if="!latestEmergency && !latestEmergencyLoading">
                  <h3>This Patient has No Latest Emergency Available</h3>
                </div>
                <div class="html2pdf__page-break">
                  <b-card-body
                    v-if="latestEmergency && !latestEmergencyLoading"
                  >
                    <div>
                      <h2>Emergency</h2>
                      <b-row class="visit-row">
                        <b-col md="6">
                          <div class="section-consultant">
                            <div>
                              <span class="h5">Time of Admission : </span
                              ><span class="h5 text-muted">{{
                                latestEmergency.date_admission
                              }}</span>
                            </div>
                          </div>
                          <div class="section-consultant">
                            <h5>Vital Sign on Admission:</h5>
                            <h5
                              class="pt-2"
                              v-if="
                                latestEmergency.glasgow_coma_scale_total_score
                              "
                            >
                              <span class="pr-1 total_score text-primary"
                                >Total score :
                                {{
                                  latestEmergency.glasgow_coma_scale_total_score
                                }}
                              </span>
                              <span
                                class="ml-1 total_score text-success"
                                v-if="
                                  latestEmergency.glasgow_coma_scale_total_score ==
                                  15
                                "
                              >
                                Best Score
                              </span>
                              <span
                                class="ml-1 total_score text-warning"
                                v-if="
                                  latestEmergency.glasgow_coma_scale_total_score <=
                                    8 &&
                                  latestEmergency.glasgow_coma_scale_total_score >
                                    3
                                "
                              >
                                Comatosed
                              </span>
                              <span
                                class="ml-1 total_score text-danger"
                                v-if="
                                  latestEmergency.glasgow_coma_scale_total_score ==
                                  3
                                "
                              >
                                Unresponsive
                              </span>
                            </h5>
                          </div>
                          <div
                            v-if="latestEmergency.vital_sign_on_admission"
                            class="section-consultant"
                          >
                            <div
                              class="mt-75"
                              v-if="
                                latestEmergency.vital_sign_on_admission
                                  .blood_pressure
                              "
                            >
                              <span class="h5">Blood Pressure : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.vital_sign_on_admission
                                  .blood_pressure
                              }}</span>
                            </div>
                            <div
                              class="mt-75"
                              v-if="
                                latestEmergency.vital_sign_on_admission
                                  .pulse_rate
                              "
                            >
                              <span class="h5">Pulse Rate : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.vital_sign_on_admission
                                  .pulse_rate
                              }}</span>
                            </div>
                            <div
                              class="mt-75"
                              v-if="
                                latestEmergency.vital_sign_on_admission
                                  .oxygen_saturation
                              "
                            >
                              <span class="h5">Oxygen Saturation : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.vital_sign_on_admission
                                  .oxygen_saturation
                              }}</span>
                            </div>
                            <div
                              class="my-75"
                              v-if="
                                latestEmergency.vital_sign_on_admission
                                  .respiratory_rate
                              "
                            >
                              <span class="h5">Respiratory Rate : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.vital_sign_on_admission
                                  .respiratory_rate
                              }}</span>
                            </div>
                          </div>
                        </b-col>
                        <b-col cols="6">
                          <div class="section-visit-sec">
                            <div>
                              <span class="h5">Admitted By : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.admitted_by
                              }}</span>
                            </div>
                          </div>
                          <div class="section-visit-sec">
                            <div>
                              <span class="h5">Cause of Admission : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.cause_of_admission
                              }}</span>
                            </div>
                          </div>
                          <div class="section-visit-sec">
                            <div>
                              <span class="h5">Treatment Received : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.treatment_received
                              }}</span>
                            </div>
                          </div>
                          <div class="section-visit-sec">
                            <div>
                              <span class="h5">State on Discharge : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.state_on_discharge
                              }}</span>
                            </div>
                          </div>
                          <div class="section-visit-sec">
                            <div>
                              <span class="h5">Referred To : </span
                              ><span class="h5 text-primary">{{
                                latestEmergency.referred_to
                              }}</span>
                            </div>
                          </div>
                        </b-col>
                        <b-col md="12">
                          <div
                            v-if="
                              latestEmergency.summery_of_the_patient_condition
                            "
                            class="section-visit-summery"
                          >
                            <h5
                              v-if="
                                latestEmergency.summery_of_the_patient_condition
                              "
                            >
                              Summery of The Patient Condition :
                            </h5>
                            <div class="summery">
                              {{
                                latestEmergency.summery_of_the_patient_condition
                              }}
                            </div>
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </b-card-body>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(9)">
            <b-col>
              <b-card>
                <template v-if="latestSubsequentLoading">
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
                <div v-if="!subsequentVisitData && !latestSubsequentLoading">
                  <h3>This Patient has No Latest Subsequent Visit Available</h3>
                </div>
                <div>
                  <div
                    v-for="item in subsequentVisitData"
                    v-if="subsequentVisitData && !latestSubsequentLoading"
                  >
                    <br />
                    <h2>Subsequent Visit at {{ item.created_at }}</h2>
                    <br />
                    <b-row class="html2pdf__page-break">
                      <b-col md="6">
                        <div class="section-visit">
                          <h4>I. Department :</h4>
                          {{ item.departments }}
                        </div>
                        <div v-if="item.emergency.key" class="section-visit">
                          <h4>II. Has an Emergent presentation :</h4>
                          <span>{{ item.emergency.key }}</span>
                          <span v-if="item.emergency.value"
                            >- {{ item.emergency.value }}</span
                          >
                        </div>
                        <div
                          class="section-visit"
                          v-if="
                            item.emergency.key == 'Yes' && item.emergency_action
                          "
                        >
                          <h4>III. Emergency action :</h4>
                          <span>{{ item.emergency_action }}</span>
                        </div>
                        <div
                          v-if="item.supportive_treatment.Antibiotic.length"
                          class="section-visit"
                        >
                          <h4>VI. Antibiotic used :</h4>
                          <ul
                            v-for="item in item.supportive_treatment.Antibiotic"
                          >
                            <li>{{ item }}</li>
                          </ul>
                        </div>
                        <div
                          v-if="item.supportive_treatment.Antifungal.length"
                          class="section-visit"
                        >
                          <h4>VII. Antifungal used :</h4>
                          <ul
                            v-for="item in item.supportive_treatment.Antifungal"
                          >
                            <li>{{ item }}</li>
                          </ul>
                        </div>
                        <div
                          v-if="item.supportive_treatment.key"
                          class="section-visit"
                        >
                          <h4>VIII. Supportive treatment :</h4>
                          <ul>
                            <li>{{ item.supportive_treatment.key }}</li>
                          </ul>
                        </div>

                        <div v-if="item.outcome.key" class="section-visit">
                          <h4>IX. Outcome / action plan :</h4>
                          <span>{{ item.outcome.key }} </span>
                        </div>
                        <div
                          v-if="item.outcome.death.key.length"
                          class="section-visit"
                        >
                          <h4>X. Death :</h4>
                          <span>
                            <ul v-for="item in item.outcome.death.key">
                              <li v-if="item == 'Cause Of Death'">
                                {{ item }}
                                <span
                                  v-if="item.outcome.death.CauseOfDeath.key"
                                >
                                  :
                                  {{ item.outcome.death.CauseOfDeath.key }}
                                  <span
                                    v-if="item.outcome.death.CauseOfDeath.value"
                                  >
                                  </span>
                                </span>
                              </li>
                              <li v-if="item == 'State Of Disease At Death'">
                                {{ item }}
                                <span
                                  v-if="
                                    item.outcome.death.StateOfDiseaseAtDeath
                                  "
                                  >:
                                  {{
                                    item.outcome.death.StateOfDiseaseAtDeath
                                  }}</span
                                >
                              </li>
                            </ul>
                          </span>
                        </div>
                        <div
                          v-if="item.supportive_treatment.next_appointment"
                          class="section-visit"
                        >
                          <h4>XI. Next appointment :</h4>
                          <span>{{
                            item.supportive_treatment.next_appointment.slice(
                              0,
                              10
                            )
                          }}</span>
                        </div>
                        <div class="section-visit">
                          <h4>XII. Senior impression :</h4>
                          <span>- {{ item.senior_impression }}</span>
                        </div>
                      </b-col>
                      <b-col md="6">
                        <div
                          v-if="item.causes.list.length"
                          class="section-visit"
                        >
                          <h4>III. Cause(s) :</h4>
                          <ul v-for="itemList in item.causes.list">
                            <li v-if="itemList == 'Chemotherapy date'">
                              {{ itemList }}
                            </li>
                            <li v-if="itemList == 'Date of assessment'">
                              {{ itemList }}
                            </li>
                            <li v-if="itemList == 'Follow up date'">
                              {{ itemList }}
                              <ul
                                v-for="secItem in item.causes.followUpDate.key"
                              >
                                <li v-if="secItem == 'Duration of follow up'">
                                  {{ secItem }}
                                  :
                                  <span>{{
                                    item.causes.followUpDate.durationOfFollowUp
                                  }}</span>
                                </li>
                                <li
                                  v-if="secItem == 'Any significant symptoms'"
                                >
                                  {{ secItem }} :
                                  <span>{{
                                    item.causes.followUpDate
                                      .anySignificantSymptoms
                                  }}</span>
                                </li>
                                <li v-if="secItem == 'The last assessment'">
                                  {{ secItem }} :
                                  <span>{{
                                    item.causes.followUpDate.theLastAssessment
                                  }}</span>
                                </li>
                              </ul>
                            </li>
                            <li v-if="itemList == 'Break Through event'">
                              {{ itemList }}

                              <ul
                                v-if="item.causes.breakThrough.length"
                                v-for="item in item.causes.breakThrough"
                              >
                                <li v-if="item == 'Fever'">
                                  {{ item }}
                                  <ul>
                                    <li v-if="item.causes.fever.duration">
                                      Duration:
                                      {{ item.causes.fever.duration }} days
                                    </li>
                                    <li
                                      v-if="
                                        item.causes.fever.prophylacticUseOf
                                          .length
                                      "
                                    >
                                      Was on prophylactic use of:
                                      <ul
                                        v-for="secItem in item.causes.fever
                                          .prophylacticUseOf"
                                      >
                                        <li>{{ secItem }}</li>
                                      </ul>
                                    </li>
                                    <li
                                      v-if="
                                        item.causes.fever.focusOfInfection.key
                                      "
                                    >
                                      {{
                                        item.causes.fever.focusOfInfection.key
                                      }}
                                      <span
                                        v-if="
                                          item.causes.fever.focusOfInfection
                                            .value
                                        "
                                      >
                                        -
                                        {{
                                          item.causes.fever.focusOfInfection
                                            .value
                                        }}
                                      </span>
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'Lymphadenopathy'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes
                                      .Lymphadenopathy.key"
                                  >
                                    <li v-if="secItem == 'Site'">
                                      {{ secItem }} :
                                      <ul
                                        v-for="thirdItem in item.causes
                                          .Lymphadenopathy.site"
                                      >
                                        <li>{{ thirdItem }}</li>
                                      </ul>
                                    </li>
                                    <li v-if="secItem == 'Size'">
                                      {{ secItem }} :
                                      <span>{{
                                        item.causes.Lymphadenopathy.size
                                      }}</span>
                                    </li>
                                  </ul>
                                </li>
                                <li
                                  v-if="
                                    item ==
                                    'Evaluation of abnormal peripheral blood'
                                  "
                                >
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes
                                      .EvaluationOfAbnormalPeripheralBlood.key"
                                  >
                                    <li v-if="secItem == 'Leukocytosis'">
                                      {{ secItem }}
                                      <ul
                                        v-for="thirdItem in item.causes
                                          .EvaluationOfAbnormalPeripheralBlood
                                          .Leukocytosis"
                                      >
                                        <li>{{ thirdItem }}</li>
                                      </ul>
                                    </li>
                                    <li v-if="secItem == 'Abnormal cell'">
                                      {{ secItem }}
                                      <ul
                                        v-for="thirdItem in item.causes
                                          .EvaluationOfAbnormalPeripheralBlood
                                          .AbnormalCell"
                                      >
                                        <li>{{ thirdItem }}</li>
                                      </ul>
                                    </li>
                                    <li
                                      v-if="
                                        secItem == 'Abnormal RBC morphology'
                                      "
                                    >
                                      {{ secItem }}
                                      <ul
                                        v-for="thirdItem in item.causes
                                          .EvaluationOfAbnormalPeripheralBlood
                                          .AbnormalRBCMorphology"
                                      >
                                        <li>{{ thirdItem }}</li>
                                      </ul>
                                    </li>
                                    <li v-else>
                                      {{ secItem }}
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'Bleeding'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes.Bleeding.key"
                                  >
                                    <li v-if="secItem == 'Site'">
                                      {{ secItem }} :
                                      <span v-if="item.causes.Bleeding.Site">{{
                                        item.causes.Bleeding.Site
                                      }}</span>
                                    </li>
                                    <li v-if="secItem == 'Duration'">
                                      {{ secItem }} :
                                      <span v-if="item.causes.Bleeding.Duration"
                                        >{{
                                          item.causes.Bleeding.Duration
                                        }}
                                        days</span
                                      >
                                    </li>
                                    <li v-if="secItem == 'Severity'">
                                      {{ secItem }} :
                                      <span
                                        v-if="item.causes.Bleeding.Severity"
                                        >{{
                                          item.causes.Bleeding.Severity
                                        }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'Mass evaluation'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes.massEvaluation
                                      .key"
                                  >
                                    <li v-if="secItem == 'Site'">
                                      {{ secItem }} :
                                      <ul
                                        v-for="thirdItem in item.causes
                                          .massEvaluation.site"
                                      >
                                        <li>{{ thirdItem }}</li>
                                      </ul>
                                    </li>
                                    <li v-if="secItem == 'Size'">
                                      {{ secItem }} :
                                      <span
                                        v-if="item.causes.massEvaluation.size"
                                        >{{
                                          item.causes.massEvaluation.size
                                        }}
                                        cm</span
                                      >
                                    </li>
                                    <li v-if="secItem == 'Descriptions'">
                                      {{ secItem }} :
                                      <span
                                        v-if="
                                          item.causes.massEvaluation
                                            .descriptions
                                        "
                                        >{{
                                          item.causes.massEvaluation
                                            .descriptions
                                        }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'Skin rash'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes.skinRash.key"
                                  >
                                    <li v-if="secItem == 'Site'">
                                      {{ secItem }} :
                                      <span v-if="item.causes.skinRash.Site">{{
                                        item.causes.skinRash.Site
                                      }}</span>
                                    </li>
                                    <li
                                      v-if="
                                        secItem ==
                                        'Percentage Of Skin Involvement'
                                      "
                                    >
                                      {{ secItem }} :
                                      <span
                                        v-if="
                                          item.causes.skinRash
                                            .percentageOfSkinInvolvement
                                        "
                                        >{{
                                          item.causes.skinRash
                                            .percentageOfSkinInvolvement
                                        }}
                                        %</span
                                      >
                                    </li>
                                    <li
                                      v-if="secItem == 'Descriptions Of Rash'"
                                    >
                                      {{ secItem }} :
                                      <ul
                                        v-for="thirdItem in item.causes.skinRash
                                          .descriptionOfRash"
                                      >
                                        <li>{{ thirdItem }}</li>
                                      </ul>
                                    </li>
                                  </ul>
                                </li>
                                <li
                                  v-if="
                                    item == 'Evaluation of abnormal blood test'
                                  "
                                >
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes
                                      .EvaluationOfAbnormalBloodTest.key"
                                  >
                                    <li>
                                      {{ secItem }}
                                      <span
                                        v-if="
                                          item.causes
                                            .EvaluationOfAbnormalBloodTest.value
                                        "
                                      >
                                        -
                                        {{
                                          item.causes
                                            .EvaluationOfAbnormalBloodTest.value
                                        }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'Locomotor presentation'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes
                                      .LocomotorPresentation.key"
                                  >
                                    <li>
                                      {{ secItem }}
                                      <span
                                        v-if="
                                          item.causes.LocomotorPresentation
                                            .value
                                        "
                                      >
                                        -
                                        {{
                                          item.causes.LocomotorPresentation
                                            .value
                                        }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'Thrombosis'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes.Thrombosis
                                      .key"
                                  >
                                    <li v-if="secItem == 'Site'">
                                      {{ secItem }} :
                                      <ul
                                        v-for="thirdItem in item.causes
                                          .Thrombosis.site"
                                      >
                                        <li>{{ thirdItem }}</li>
                                      </ul>
                                    </li>
                                    <li
                                      v-if="
                                        secItem == 'Single site vs Multiple?'
                                      "
                                    >
                                      {{ secItem }} :
                                      <span>{{
                                        item.causes.Thrombosis.SingleVMultiple
                                      }}</span>
                                    </li>
                                    <li
                                      v-if="
                                        secItem == 'First attack vs Recurrent?'
                                      "
                                    >
                                      {{ secItem }} :
                                      <span>{{
                                        item.causes.Thrombosis.FirstVRecurrent
                                      }}</span>
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'Neurological presentation'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes
                                      .NeurologicalPresentation.key"
                                  >
                                    <li>
                                      {{ secItem }}
                                      <span
                                        v-if="
                                          item.causes.NeurologicalPresentation
                                            .value
                                        "
                                      >
                                        -
                                        {{
                                          item.causes.NeurologicalPresentation
                                            .value
                                        }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                                <li v-if="item == 'GIT presentation'">
                                  {{ item }}
                                  <ul
                                    v-for="secItem in item.causes
                                      .GITPresentation.key"
                                  >
                                    <li>
                                      {{ secItem }}
                                      <span
                                        v-if="
                                          item.causes.GITPresentation.key ==
                                          'Loss of weight'
                                        "
                                      >
                                        :
                                        {{
                                          item.causes.GITPresentation
                                            .LossOfWeight
                                        }}
                                        %
                                      </span>
                                      <span
                                        v-if="
                                          item.causes.GITPresentation.key ==
                                          'value'
                                        "
                                      >
                                        :
                                        {{
                                          item.causes.GITPresentation.value
                                        }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(10)">
            <b-col>
              <b-card>
                <template v-if="latestSupportiveLoading">
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
                <div v-if="!latestSupportiveInfo && !latestSupportiveLoading">
                  <h3>This Patient has No Latest Supportive Visit Available</h3>
                </div>
                <div class="html2pdf__page-break">
                  <div v-if="latestSupportiveInfo && !latestSupportiveLoading">
                    <h2 class="mb-2">Supportive</h2>
                    <br /><br />
                    <div>
                      <h4 style="display: inline" class="ml-1">
                        Blood group &RH :
                        <span class="ml-1 text-primary">{{
                          latestSupportiveInfo.blood_group_rh
                        }}</span>
                      </h4>
                      <br /><br /><br />
                      <div>
                        <h4 class="ml-1 mb-1">
                          Is the patient need irradiated blood component?
                          <span class="ml-1 text-primary">{{
                            latestSupportiveInfo.is_need_irradiated_blood.key
                          }}</span>
                        </h4>
                        <h5
                          class="ml-1 mb-1 text-primary"
                          v-if="
                            latestSupportiveInfo.is_need_irradiated_blood.key ==
                            'Yes'
                          "
                        >
                          - Because he/she known case of :
                          <span class="ml-1 text-primary">
                            {{
                              latestSupportiveInfo.is_need_irradiated_blood
                                .value
                            }}
                          </span>
                        </h5>
                      </div>
                      <br /><br />
                      <div>
                        <h4 class="ml-1 mb-1">
                          has allergy from blood component previously?
                          <span class="ml-1 text-primary">{{
                            latestSupportiveInfo
                              .has_allergy_from_blood_previously.key
                          }}</span>
                        </h4>
                        <h5
                          class="ml-1 mb-1 text-primary"
                          v-if="
                            latestSupportiveInfo
                              .has_allergy_from_blood_previously.key == 'Yes'
                          "
                        >
                          - It is :
                          <span class="ml-1 text-primary">
                            {{
                              latestSupportiveInfo
                                .has_allergy_from_blood_previously.value
                            }}
                          </span>
                        </h5>
                      </div>
                      <br /><br />
                      <div>
                        <h4 class="ml-1 mb-1">
                          has allergy from blood component previously?
                          <span
                            v-if="latestSupportiveInfo.is_received_irradiated"
                            class="ml-1 text-primary"
                            >Yes</span
                          >
                          <span
                            v-if="!latestSupportiveInfo.is_received_irradiated"
                            class="ml-1 text-primary"
                            >No</span
                          >
                        </h4>
                      </div>
                      <br /><br />
                      <div style="flex: 1 1 500px">
                        <table style="margin-left: 2rem; width: 40%">
                          <tr>
                            <td
                              style="width: 25%; height: 4rem"
                              class="ml-3 h5"
                            >
                              Hb =
                            </td>
                            <td style="width: 75%">
                              <span class="font-weight-bolder text-primary"
                                >{{ this.latestSupportiveInfo.hb }}
                              </span>
                              <span style="min-width: 20%">g/dl</span> (before
                              receiving blood)
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="width: 25%; height: 4rem"
                              class="ml-3 h5"
                            >
                              PLT =
                            </td>
                            <td style="width: 75%">
                              <span class="font-weight-bolder text-primary"
                                >{{ this.latestSupportiveInfo.plt }}
                              </span>
                              <span style="min-width: 20%"
                                >10<sup>9</sup>/L</span
                              >
                              (before receiving plt)
                            </td>
                          </tr>
                        </table>
                      </div>
                      <br /><br />
                      <div>
                        <h4 class="ml-1 mb-1">
                          Any complication if occurred :
                        </h4>
                        <div
                          style="
                            margin-left: 2.5rem;
                            margin-top: 2rem;
                            max-width: 70%;
                          "
                        >
                          <h5 class="section-visit ml-1 text-primary">
                            {{ latestSupportiveInfo.description }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(11)">
            <b-col>
              <b-card v-if="!pharmacyLoading">
                <div v-if="!pharmacyInfo && !pharmacyLoading">
                  <h3>This Patient has No Pharmacy Presecriptions Available</h3>
                </div>
                <table v-if="pharmacyInfo" class="edit-drugs-table">
                  <tr>
                    <td style="width: 15px">No</td>
                    <td style="width: 80px">Drug Scientific Name</td>
                    <td style="width: 80px">Drug Brand Name</td>
                    <td style="width: 40px">Dose</td>
                    <td style="width: 40px">QTY</td>
                    <td>Notes</td>
                    <td style="width: 30px">Source</td>
                    <td style="width: 30px">Date</td>
                  </tr>
                  <tr v-for="(i, index) in pharmacyInfo">
                    <td style="width: 15px" class="">{{ index + 1 }}</td>
                    <td>
                      {{ i.drug_scientific_name.name }}
                    </td>
                    <td>
                      {{ i.drug.name }}
                    </td>
                    <td v-if="i.drug_information">
                      {{
                        i.drug_information.dose + "" + i.drug_information.unit
                      }}
                    </td>
                    <td>
                      {{ i.quantity }}
                    </td>
                    <td>
                      {{ i.notes }}
                    </td>
                    <td>
                      {{ i.is_external ? "External" : "Internal" }}
                    </td>
                    <td>
                      {{ i.created_at }}
                    </td>
                  </tr>
                </table>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(12)">
            <b-col>
              <b-card v-if="labLoading">
                <template>
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner label="Loading..." />
                    </div>
                  </div>
                </template>
              </b-card>
              <b-card v-if="!labLoading">
                <div v-if="!labInfo && !labLoading">
                  <h3>This Patient has No Pharmacy Presecriptions Available</h3>
                </div>
                <table v-if="labInfo" class="edit-drugs-table">
                  <tr>
                    <td>Name</td>
                    <td>Result</td>
                    <td>Normal Range</td>
                    <td>Result As To Normal Range</td>
                    <!-- <td>Date</td> -->
                  </tr>
                  <tr v-for="(i, index) in pharmacyInfo" :key="index">
                    <td>
                      {{ i.name }}
                    </td>
                    <td>
                      {{ i.result }}
                    </td>
                    <td>
                      {{ i.normalRange }}
                    </td>
                    <td>
                      {{ i.resultAsToNormalRange }}
                    </td>
                  </tr>
                </table>
              </b-card>
            </b-col>
          </b-row>
          <b-row v-if="itemClickedList.includes(13)">
            <b-col>
              <b-card v-if="assessmentLoading">
                <template>
                  <div>
                    <div class="d-flex justify-content-center mb-1">
                      <b-spinner assessmentel="Loading..." />
                    </div>
                  </div>
                </template>
              </b-card>
              <b-card v-if="!assessmentLoading">
                <div v-if="!assessmentInfo && !assessmentLoading">
                  <h3>This Patient has No Pharmacy Presecriptions Available</h3>
                </div>
                <table v-if="assessmentInfo" class="edit-drugs-table">
                  <tr style="font-weight: 900">
                    <td>Goal of Assessment</td>
                    <td>Type of Response</td>
                    <td>Second step</td>
                    <td>Date</td>
                  </tr>
                  <tr v-for="(i, index) in assessmentInfo" :key="index">
                    <td>
                      {{ i.goal_of_assesment }}
                    </td>
                    <td>
                      {{ i.type_of_response }}
                    </td>
                    <td>
                      {{ i.second_step }}
                    </td>
                    <td>
                      {{ i.created_at }}
                    </td>
                  </tr>
                </table>
              </b-card>
            </b-col>
          </b-row>
        </section>
      </vue-html2pdf>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BLink,
  BDropdown,
  BDropdownItem,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
  VBModal,
  BCardText,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import permissionChecker from "@/mixins/permissionChecker";
import VueHtml2pdf from "vue-html2pdf";

export default {
  mixins: [permissionChecker],
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BLink,
    BDropdown,
    BDropdownItem,
    BTooltip,
    vSelect,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    BCardText,
    BFormCheckbox,
    BFormCheckboxGroup,
    BCardBody,
    VueHtml2pdf,
  },
  data() {
    return {
      patientData: [],
      cities: [],
      selected: "",
      wbc: "",
      n: "",
      hb: "",
      plt: "",
      l: "",
      blast: "",
      blood_film: "",
      b_urea: "",
      s_ca: "",
      alt: "",
      alp: "",
      s_crea: "",
      uric_acid: "",
      ast: "",
      tsb: "",
      option: [],
      itemsField: "",
      visitList: {
        presenting_Symptom: [],
        peformance_state: [],
        on_examination: [],
        initial_investigation_before_admission: [],
        senior_impression: [],
        road_map: [],
        investigation_send: [],
      },
      firstVisitLoading: true,
      removeCreate: false,
      params: {
        form: {},
        path: "",
      },
      itemsList: [
        "First Visit",
        "Latest Diagnosis",
        "Latest Prognosis",
        "Active Treatment Protocol",
        "Latest Treatment Protocol",
        "Active Relapse Protocol",
        "Latest Relapse Protocol",
        "Consultant Visits",
        "Emergency Visits",
        "Subsequent Visits",
        "Supportive Visits",
        "Pharamcy Prescriptions",
        "Lab Tests",
        "Protocols Assessment",
      ],
      answer: null,
      patientDataLoading: true,
      firstVisitInput: {},
      updatedVisitFormcheck: "",
      completedSubmit: false,
      loadDiagnosis: true,
      LatestdiagnosisId: "",
      Latestdiagnosis: "",
      loadPrognosis: true,
      prognosisTitle: "",
      treatmentForPatient: "",
      treatmentLoading: true,
      latestTreatmentForPatient: "",
      latestTreatmentLoading: true,
      relapseForPatient: "",
      relapseLoading: true,
      latestRelapseForPatient: "",
      latestRelapseLoading: true,
      latestConsultation: "",
      latestConsultationLoading: true,
      latestEmergency: "",
      latestEmergencyLoading: true,
      subsequentVisitData: "",
      latestSubsequentLoading: true,
      latestSupportiveInfo: "",
      latestSupportiveLoading: true,
      pharmacyInfo: "",
      labInfo: "",
      assessmentInfo: [],
      pharmacyLoading: true,
      labLoading: true,
      assessmentLoading: true,
      itemClickedList: [],
    };
  },
  mounted() {
    this.getPatientInfo();
    this.getCities();
  },
  methods: {
    async getPatientInfo() {
      await this.getPatient(`/patient?filter[uuid]=${this.$route.params.id}`);
      this.patientData = this.all_data.data[0];
      this.patientDataLoading = false;
    },
    async getCities() {
      await this.getList(`/city`);
      for (let item in this.all_data.data) {
        this.cities.push(this.all_data.data[item].name);
      }
    },
    async getFirstVisit() {
      await this.getList(`/patient/first/visit/${this.$route.params.id}`)
        .then((res) => {})
        .catch((err) => {});
      if (this.all_data) {
        this.itemsField = this.all_data;
      }
      this.firstVisitLoading = false;
    },
    async getDiagnosis() {
      await this.getList(
        `/patient/diagnosis?take=5&sort=-id&include=disease_item&patient_id=${this.$route.params.id}`
      );
      if (this.all_data.data[0]) {
        this.Latestdiagnosis = this.all_data.data[0].disease_item.name;
        this.LatestdiagnosisId = this.all_data.data[0].id;
      }
      this.loadDiagnosis = false;
      this.showPatientItemPrognosis();
    },
    async showPatientItemPrognosis() {
      await this.getPrognosis(
        `prognosis/patient/disease/${this.LatestdiagnosisId}?take=5`
      )
        .then((res) => {})
        .catch((err) => {});
      if (this.prognosis[0]) {
        this.patienPrognosisInfo = this.prognosis[0];
      }
      this.loadPrognosis = false;
    },
    async getActiveTreatmentInfo() {
      await this.getList(`/treatment/patient/${this.$route.params.id}`)
        .then((res) => {
          if (this.all_data) {
            this.treatmentForPatient = this.all_data;
          }
        })
        .catch((err) => {});
      this.treatmentLoading = false;
    },
    async getLatestTreatmentInfo() {
      await this.getList(
        `/treatment/history?include=protocol&filter[patient_id]=${this.$route.params.id}&sort=-id`
      );
      if (this.all_data.data[0]) {
        this.latestTreatmentForPatient = this.all_data.data[0];
      }
      this.latestTreatmentLoading = false;
    },
    async getActiveRelapseInfo() {
      await this.getList(`/relapse/patient/${this.$route.params.id}`)
        .then((res) => {
          if (this.all_data) {
            this.relapseForPatient = this.all_data;
            console.log(this.relapseForPatient);
          }
        })
        .catch((err) => {});
      this.relapseLoading = false;
    },
    async getLatestRelapseInfo() {
      await this.getList(
        `/relapse/history?include=protocol&filter[patient_id]=${this.$route.params.id}&sort=-id`
      );
      if (this.all_data.data[0]) {
        this.latestRelapseForPatient = this.all_data.data[0];
      }
      this.latestRelapseLoading = false;
    },
    async getConsultation() {
      await this.getList(
        `/consultation?filter[patient_id]=${this.$route.params.id}&sort=-id`
      );
      if (this.all_data.data[0]) {
        this.latestConsultation = this.all_data.data[0];
      }
      this.latestConsultationLoading = false;
    },
    async getEmergency() {
      await this.getList(
        `/emergency?filter[patient_id]=${this.$route.params.id}&sort=-id`
      );
      if (this.all_data.data[0]) {
        this.latestEmergency = this.all_data.data[0];
      }
      this.latestEmergencyLoading = false;
    },
    async getSubsequent() {
      await this.getList(
        `subsequent-visit?filter[patient_id]=${this.$route.params.id}`
      );
      if (this.all_data.data.length) {
        this.subsequentVisitData = this.all_data.data;
      }
      this.latestSubsequentLoading = false;
    },
    async getSupportive() {
      await this.getList(
        `patient-supportive?filter[patient_id]=${this.$route.params.id}`
      );
      if (this.all_data.data[0]) {
        this.latestSupportiveInfo = this.all_data.data[0];
      }
      this.latestSupportiveLoading = false;
    },
    async getPrescription() {
      await this.getList(
        `/medical/prescription?include=drug, drugInformation, drugScientificName&filter[card.patient_id]=${this.$route.params.id}&take=1000`
      );
      if (this.all_data.data.length) {
        this.pharmacyInfo = this.all_data.data;
      }
      this.pharmacyLoading = false;
    },
    async getLabResults() {
      await this.getList(
        `/test/result?take=1000&page=${this.page}&filter[hisPatientId]=${this.$route.params.id}`
      );
      if (this.all_data.data.length) {
        this.labInfo = this.all_data.data;
      }
      this.labLoading = false;
    },
    async getAssessment() {
      await this.getList(
        `/assessment?filter[patient_id]=${this.$route.params.id}&include=treatment.protocol`
      ).then(() => {
        if (this.all_data.data.length) {
          for (let item in this.all_data.data) {
            this.assessmentInfo.push(this.all_data.data[item]);
          }
        }
      });

      await this.getList(
        `/relapse/assessments?filter[patient_id]=${this.$route.params.id}&include=relapse.protocol`
      ).then(() => {
        if (this.all_data.data.length) {
          for (let item in this.all_data.data) {
            this.assessmentInfo.push(this.all_data.data[item]);
          }
        }
      });

      this.assessmentLoading = false;
    },
    generateReportAll() {
      this.$refs.html2PdfAll.generatePdf();
    },
    itemClicked(id) {
      if (this.itemClickedList.includes(id)) {
        this.itemClickedList.splice(this.itemClickedList.indexOf(id), 1);
      } else {
        !this.Latestdiagnosis && id == 2 && this.loadDiagnosis
          ? ""
          : this.itemClickedList.push(id);
        switch (id) {
          case 0:
            this.getFirstVisit();
            break;
          case 1:
            this.getDiagnosis();
            break;
          case 2:
            // prognosis
            if (!this.Latestdiagnosis && this.loadDiagnosis) {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Wrong Selection",
                  icon: "InfoIcon",
                  variant: "danger",
                  text: "You must show the patient diagnosis before showing its Risk Stratification",
                },
              });
            }
            break;
          case 3:
            this.getActiveTreatmentInfo();
            break;
          case 4:
            this.getLatestTreatmentInfo();
            break;
          case 5:
            this.getActiveRelapseInfo();
            break;
          case 6:
            this.getLatestRelapseInfo();
            break;
          case 7:
            this.getConsultation();
            break;
          case 8:
            this.getEmergency();
            break;
          case 9:
            this.getSubsequent();
            break;
          case 10:
            this.getSupportive();
            break;
          case 11:
            this.getPrescription();
            break;
          case 12:
            this.getLabResults();
            break;
          case 13:
            this.getAssessment();
            break;
        }
      }
    },
  },
};
</script>
<style scoped>
.font-modify {
  letter-spacing: normal !important;
}

.pdf-content {
  margin: 2rem;
}

.modify_result_display {
  width: 25rem;
  margin: auto;
  color: rgb(255, 255, 255);
}

.modify_result_display_div {
  border-radius: 8px;
  margin: -22px;
  padding: 10px;
  margin-top: 10px;
  background: rgb(25, 0, 255);
}

.Risk_bg {
  margin: 1.5rem 0.5rem;
  border-radius: 8px;
  border-top: 3px solid rgb(25, 0, 255);
  border-left: 3px solid rgb(25, 0, 255);
  border-right: 3px solid rgb(25, 0, 255);
}

.timeline {
  max-width: 300px;
  color: #fdfdfd;
  padding: 30px 10px;
}

.timeline ul {
  list-style-type: none;
  border-left: 2px solid #094a68;
  padding: 10px 5px;
}

.timeline ul li {
  padding: 20px 10px;
  position: relative;
  cursor: pointer;
  transition: 0.5s;
  margin-top: 5px;
  max-width: 80%;
  word-wrap: break-word;
}

.timeline ul li span {
  color: #094a68;
  word-wrap: break-word;
}

.timeline ul li:before {
  position: absolute;
  content: "";
  width: 10px;
  height: 10px;
  background-color: #34ace0;
  border-radius: 50%;
  left: -11px;
  top: 28px;
  transition: 0.5s;
}

.timeline ul li:hover:before {
  background-color: rgb(255, 208, 0);
  box-shadow: 0px 0px 10px 2px rgb(255, 208, 0);
}

.timeline ul .clicked:before {
  background-color: #0f0;
  box-shadow: 0px 0px 10px 2px #0f0;
}

.timeline ul .unclicked:before {
  background-color: #34ace0;
  box-shadow: none;
}

@media (max-width: 300px) {
  .timeline {
    width: 100%;
    padding: 30px 5px 30px 10px;
  }

  .timeline ul li .content h3 {
    color: #34ace0;
    font-size: 15px;
  }
}

.section-visit {
  background: #ebebeb;
  margin-bottom: 1rem;
  padding: 1rem;
}

.section-consultant {
  margin: 1.5rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.modify-consulting-paper {
  padding: 1rem;
  max-height: 100%;
  max-width: 100%;
}

.visit-row {
  margin-top: 2rem;
}

.section-visit-sec {
  margin: 1.75rem 0.5rem;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.section-visit-summery {
  margin: 0.5rem;
  padding: 1rem;
  color: black;
  border-radius: 8px;
  box-shadow: 0px 6px 24px #e4e4e4;
}

.summery {
  background-color: rgba(237, 238, 245, 0.431);
  padding: 1.5rem;
  margin: 1rem;
  border-radius: 5px;
}

.total_score {
  background-color: rgb(237, 238, 245);
  padding: 0.5rem 1rem;
  border-radius: 15px;
  box-shadow: 0px 6px 10px #ebebeb;
}

table,
td,
th {
  border: 1px solid;
}

.sign-table,
.sign-table > tr > td {
  border: none !important;
}

table {
  width: 100%;
  background: white;
  border-collapse: collapse;
}

table > tr > td {
  width: 6rem;
  text-align: center;
}

.patient-table > tr > td {
  padding-left: 0.5rem;
  border: 1px solid;
  text-align: left;
}
</style>